import React, { useEffect, useState } from "react";
import HaritaBasvurulari from "./HaritaBasvurulari";
import MespuanGorevOnaylari from "./MespuanGorevOnaylari";
import MarketplaceIlanOnaylari from "./MarketplaceIlanOnaylari";

import MespuanReklamBasvurulari from "./MespuanReklamBasvurulari";





/*
  BAYİ YÖNETİMİ – FINAL (SERVER + DB UYUMLU)
  ✔ Kurum ekle
  ✔ Kurum listele
  ✔ Kurum sil
  ✔ Login / Logout
*/

const API = "https://api.haymestasarim.com/api";

const ALLOWED_ADMIN_EMAILS = [
  "tayfununac@admin.com",
  "yildizmesut.ch@gmail.com",
];

function decodeJwtPayload(token) {
  try {
    if (!token || !String(token).includes(".")) return null;

    const base64Url = String(token).split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join("")
    );

    return JSON.parse(json);
  } catch {
    return null;
  }
}

function getTokenEmail(token) {
  const payload = decodeJwtPayload(token);

  return String(
    payload?.email ||
    payload?.mail ||
    payload?.user_email ||
    ""
  )
    .trim()
    .toLowerCase();
}

function isAllowedAdminToken(token) {
  const tokenEmail = getTokenEmail(token);
  return ALLOWED_ADMIN_EMAILS.includes(tokenEmail);
}


const DOGRUDAN_BAYI_ORANI = 40;
const UST_SPONSOR_ORANI = 10;
const KURUM_PAGE_SIZE = 25;

const ISLEM_TIPLERI = [
  { value: "satis", label: "Satış" },
  { value: "demo", label: "Demo" },
  { value: "yenileme", label: "Yenileme" },
  { value: "kurulum", label: "Kurulum" },
];

function addOneYear(dateValue) {
  if (!dateValue) return "";

  const d = new Date(dateValue);
  if (Number.isNaN(d.getTime())) return "";

  d.setFullYear(d.getFullYear() + 1);
  return d.toISOString().slice(0, 10);
}

function numValue(value) {
  const n = Number(String(value || "0").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
}

function hesaplaHakedis(satisTutar, oran) {
  const tutar = numValue(satisTutar);
  const cleanOran = numValue(oran);

  return Math.round(((tutar * cleanOran) / 100) * 100) / 100;
}

function paraFormat(value) {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
  }).format(numValue(value));
}

async function readApiPayload(response) {
  const raw = await response.text();

  if (!raw) return {};

  try {
    return JSON.parse(raw);
  } catch {
    return { message: raw };
  }
}

function getApiErrorText(payload, response, fallback = "İşlem tamamlanamadı") {
  const message =
    payload?.message ||
    payload?.error ||
    payload?.detail ||
    fallback;
  const detail =
    payload?.detail && payload.detail !== message
      ? payload.detail
      : payload?.error_detail && payload.error_detail !== message
        ? payload.error_detail
        : "";
  const code = payload?.error_code || payload?.code || "";
  const http = response?.status
    ? `HTTP ${response.status}${response.statusText ? ` ${response.statusText}` : ""}`
    : "";
  const technical = [http, code && `Kod: ${code}`, detail]
    .filter(Boolean)
    .join(" · ");

  return technical ? `${message} (${technical})` : message;
}

function makeRequestError(payload, response, fallback) {
  const error = new Error(getApiErrorText(payload, response, fallback));
  error.payload = payload;
  error.status = response?.status;
  return error;
}

function normalizeLocationPayload(payload, type = "district") {
  const candidates = [
    payload,
    payload?.data,
    payload?.results,
    type === "city" ? payload?.cities : payload?.districts,
    type === "city" ? payload?.iller : payload?.ilceler,
    type === "city" ? payload?.data?.cities : payload?.data?.districts,
    type === "city" ? payload?.data?.iller : payload?.data?.ilceler,
  ];
  const list = candidates.find(Array.isArray) || [];

  return list
    .map((item) => {
      const id = type === "city"
        ? item?.id ?? item?.city_id ?? item?.il_id ?? item?.province_id
        : item?.id ?? item?.district_id ?? item?.ilce_id ?? item?.county_id;
      const name = type === "city"
        ? item?.name ?? item?.city_name ?? item?.il_adi ?? item?.province_name
        : item?.name ?? item?.district_name ?? item?.ilce_adi ?? item?.county_name;

      return {
        ...item,
        id: id === undefined || id === null ? "" : String(id),
        name: String(name || "").trim(),
      };
    })
    .filter((item) => item.id && item.name);
}

function getNetworkRowKey(row = {}) {
  return [
    row.source || "network",
    row.id || row.user_id || row.kurum_id || "",
    row.node_code || row.yeni_kurum_code || row.talep_code || row.email || "",
  ].join(":");
}

function getNetworkNodeCode(row = {}) {
  return String(
    row.node_code ||
    row.yeni_kurum_code ||
    row.yeni_kurum_short_code ||
    row.talep_code ||
    row.talep_short_code ||
    row.kurum_code ||
    row.code ||
    row.short_code ||
    ""
  ).trim();
}

function buildNetworkForest(rows = []) {
  const nodes = rows.map((row) => ({
    ...row,
    node_code: getNetworkNodeCode(row),
    children: [],
  }));
  const byCode = new Map();

  nodes.forEach((node) => {
    if (node.node_code && !byCode.has(node.node_code)) {
      byCode.set(node.node_code, node);
    }
  });

  const roots = [];
  nodes.forEach((node) => {
    const parentCode = String(node.ref_code || "").trim();
    const parent = parentCode ? byCode.get(parentCode) : null;

    if (parent && parent !== node) parent.children.push(node);
    else roots.push(node);
  });

  const sorter = (a, b) =>
    String(a.kurum_adi || a.ad_soyad || "").localeCompare(
      String(b.kurum_adi || b.ad_soyad || ""),
      "tr"
    );
  const sortBranch = (branch) => {
    branch.sort(sorter);
    branch.forEach((node) => sortBranch(node.children));
  };

  sortBranch(roots);
  return roots;
}

export default function AdminLogin() {


/* ================= NETWORK USERS ================= */
const [networkUsers, setNetworkUsers] = useState([]);
const [networkOpen, setNetworkOpen] = useState(false);
const [networkSearch, setNetworkSearch] = useState("");
const [networkOwnerFilter, setNetworkOwnerFilter] = useState("");
const [networkExpandedByKey, setNetworkExpandedByKey] = useState({});
const [networkMoveTargetByKey, setNetworkMoveTargetByKey] = useState({});
const [networkMoveLoadingKey, setNetworkMoveLoadingKey] = useState("");
const [draggedNetworkKey, setDraggedNetworkKey] = useState("");
const [networkDropKey, setNetworkDropKey] = useState("");

const pickFirst = (obj, keys, fallback = "") => {
  for (const key of keys) {
    if (obj?.[key] !== undefined && obj?.[key] !== null && String(obj[key]).trim() !== "") {
      return obj[key];
    }
  }
  return fallback;
};

const normalizeListPayload = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.users)) return payload.users;
  if (Array.isArray(payload?.rows)) return payload.rows;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.networkUsers)) return payload.networkUsers;
  return [];
};




const normalizeNetworkUser = (u = {}) => ({
  ...u,
  id: pickFirst(u, ["id", "user_id", "kullanici_id", "panel_user_id", "kurum_id", "old_id"], ""),
  ad_soyad: pickFirst(u, ["ad_soyad", "name", "full_name", "kullanici_adi", "kurum_adi", "ad"], ""),
  kurum_adi: pickFirst(u, ["kurum_adi", "firma_adi", "company_name", "ad"], ""),
  email: pickFirst(u, ["email", "mail", "user_email", "kullanici_email", "panel_email"], ""),
  telefon: pickFirst(u, ["telefon", "phone", "gsm", "tel"], ""),
  ref_code: pickFirst(u, ["ref_code", "referans_code", "davet_kodu", "parent_code", "sponsor_code"], ""),
  davet_eden_adi: pickFirst(u, ["davet_eden_adi", "referans_adi", "sponsor_name", "parent_name"], ""),
  node_code: pickFirst(u, ["node_code", "yeni_kurum_code", "talep_code", "kurum_code", "code", "short_code"], ""),
  network_status: pickFirst(u, ["network_status", "status", "durum"], "aktif"),
  source: "network",
});

const fetchNetworkUsers = async () => {
  try {
    const res = await fetch(`${API}/admin/network/users`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = await readApiPayload(res);

    if (res.ok) {
      setNetworkUsers(normalizeListPayload(data).map(normalizeNetworkUser));
    } else {
      console.error("Network kullanıcıları alınamadı", data);
      setNetworkUsers([]);
      setMessage({
        type: "error",
        text: getApiErrorText(data, res, "Network kullanıcıları alınamadı"),
      });
    }
  } catch (err) {
    console.error("Network kullanıcıları alınamadı", err);
    setNetworkUsers([]);
    setMessage({
      type: "error",
      text: `Network kullanıcıları alınamadı: ${err.message || "Bağlantı hatası"}`,
    });
  }
};


/* ================= ÖDEME TALEPLERİ ================= */
const [odemeTalepleri, setOdemeTalepleri] = useState([]);
const [odemeOpen, setOdemeOpen] = useState(false);

const fetchOdemeTalepleri = async () => {
  try {
    const res = await fetch(`${API}/admin/payout-requests`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    if (res.ok) {
      setOdemeTalepleri(data || []);
    }
  } catch (err) {
    console.error("Ödeme talepleri alınamadı", err);
  }
};


/* ================= PAKET BAŞVURULARI ================= */
const [paketBasvurulari, setPaketBasvurulari] = useState([]);
/* ================= PAKET DETAYLARI ================= */
const [paketDetaylari, setPaketDetaylari] = useState([]);


/* ================= PAKET FİLTRE ================= */
const [paketFilter, setPaketFilter] = useState("Tümü");

/* ================= FİLTRELİ PAKET LİSTESİ ================= */
const filteredPaketler = paketBasvurulari.filter(p => {
  if (paketFilter === "Tümü") return true;
  return p.durum === paketFilter;
});

/* ================= PAKET BAŞVURULARINI GETİR ================= */
const fetchPaketBasvurulari = async () => {
  try {
    const res = await fetch(`${API}/admin/paket/basvurular`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();

    if (res.ok) {
      setPaketBasvurulari(data.basvurular || []);
    }
  } catch (err) {
    console.error("Paket başvuruları alınamadı", err);
  }
};


/* ================= BAYİ BAŞVURULARI ================= */
const [bayiBasvurulari, setBayiBasvurulari] = useState([]);
const [bayiBasvuruFilter, setBayiBasvuruFilter] = useState("acik_basvurular");
const [bayiBasvuruLoadingId, setBayiBasvuruLoadingId] = useState(null);
const [pendingDistrictFromBasvuru, setPendingDistrictFromBasvuru] = useState("");
const [bayiBasvuruOpenById, setBayiBasvuruOpenById] = useState({});
const [approvalDialog, setApprovalDialog] = useState(null);
const [approvalConfirmed, setApprovalConfirmed] = useState(false);
const [approvalNote, setApprovalNote] = useState("");
const [applicationDistrictNames, setApplicationDistrictNames] = useState({});
const [bayiBasvuruRefDraft, setBayiBasvuruRefDraft] = useState({});

const filteredBayiBasvurulari = bayiBasvurulari.filter(b => {
  if (bayiBasvuruFilter === "Tümü") return true;

  if (bayiBasvuruFilter === "acik_basvurular") {
    return b.durum === "kayit_bekliyor" || b.durum === "bayi_adayi";
  }

  return b.durum === bayiBasvuruFilter;
});

const normalizeBayiBasvuru = (b = {}) => {
  const ilValue = pickFirst(b, [
    "il",
    "il_id",
    "city_id",
    "sehir_id",
    "province_id",
  ], "");

  const ilceValue = pickFirst(b, [
    "ilce",
    "ilce_id",
    "district_id",
    "county_id",
    "town_id",
  ], "");

  return {
    ...b,

    // Admin formuna aktarırken kesin yakalansın
    il: ilValue,
    ilce: ilceValue,

    // Tabloda görünen adlar
    il_adi: pickFirst(b, [
      "il_adi",
      "city_name",
      "sehir_adi",
      "province_name",
      "il_name",
    ], ""),

    ilce_adi: pickFirst(b, [
      "ilce_adi",
      "district_name",
      "county_name",
      "town_name",
      "ilce_name",
    ], ""),
  };
};

const hydrateApplicationDistrictNames = async (applications = []) => {
  const cityIds = Array.from(
    new Set(
      applications
        .map((item) => String(item.il || item.il_id || "").trim())
        .filter(Boolean)
    )
  );

  if (!cityIds.length) return;

  const results = await Promise.all(
    cityIds.map(async (cityId) => {
      try {
        const res = await fetch(
          `${API}/auth/locations/tr/districts?city_id=${encodeURIComponent(cityId)}`
        );
        const payload = await readApiPayload(res);
        const list = normalizeLocationPayload(payload, "district");

        return { cityId, list: res.ok ? list : [] };
      } catch (err) {
        console.warn("Başvuru ilçe adları alınamadı:", cityId, err);
        return { cityId, list: [] };
      }
    })
  );

  setApplicationDistrictNames((prev) => {
    const next = { ...prev };

    results.forEach(({ cityId, list }) => {
      list.forEach((districtItem) => {
        const districtId = String(
          districtItem.id ||
          districtItem.ilce_id ||
          districtItem.district_id ||
          ""
        ).trim();
        const districtName = String(
          districtItem.name ||
          districtItem.ilce_adi ||
          districtItem.district_name ||
          ""
        ).trim();

        if (districtId && districtName) {
          next[`${cityId}:${districtId}`] = districtName;
        }
      });
    });

    return next;
  });
};

const fetchBayiBasvurulari = async () => {
  try {
    const res = await fetch(`${API}/admin/bayilik/davetler`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await readApiPayload(res);

    if (res.ok) {
      const list = normalizeListPayload(data);
      const normalized = list.map(normalizeBayiBasvuru);
      setBayiBasvurulari(normalized);
      hydrateApplicationDistrictNames(normalized);
    } else {
      console.error("Bayi başvuruları alınamadı", data);
      setBayiBasvurulari([]);
      setMessage({
        type: "error",
        text: getApiErrorText(data, res, "Bayi başvuruları alınamadı"),
      });
    }
  } catch (err) {
    console.error("Bayi başvuruları alınamadı", err);
    setBayiBasvurulari([]);
    setMessage({
      type: "error",
      text: `Bayi başvuruları alınamadı: ${err.message || "Bağlantı hatası"}`,
    });
  }
};

const getBayiBasvuruDurumText = (durum) => {
  if (durum === "kayit_bekliyor") return "Onay Bekliyor";
  if (durum === "bayi_adayi") return "Bayi Adayı";
  if (durum === "aktif_bayi") return "Aktif Bayi";
  if (durum === "reddedildi") return "Reddedildi";
  if (durum === "pasif") return "Pasif";
  return durum || "-";
};

const getBayiBasvuruDurumStyle = (durum) => {
  const base = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "5px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 800,
    whiteSpace: "nowrap",
  };

  if (durum === "aktif_bayi") {
    return { ...base, background: "#dcfce7", color: "#166534" };
  }

  if (durum === "bayi_adayi") {
    return { ...base, background: "#dbeafe", color: "#1d4ed8" };
  }

  if (durum === "reddedildi" || durum === "pasif") {
    return { ...base, background: "#fee2e2", color: "#991b1b" };
  }

  return { ...base, background: "#fef3c7", color: "#92400e" };
};


const [token, setToken] = useState(() => {
  const savedToken = localStorage.getItem("admin_token");

  if (savedToken && isAllowedAdminToken(savedToken)) {
    return savedToken;
  }

  localStorage.removeItem("admin_token");
  return null;
});



/* ===== MOBILE FIX (SADECE CSS) ===== */
useEffect(() => {
  const mobileStyle = document.createElement("style");
  mobileStyle.innerHTML = `
    .bayi-admin-filterbar,
    .bayi-admin-actions,
    .bayi-admin-network-toolbar {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      align-items: center;
    }

    .bayi-admin-application-list,
    .bayi-admin-network-tree {
      display: grid;
      gap: 12px;
    }

    .bayi-admin-app-card,
    .bayi-admin-network-node {
      min-width: 0;
      transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease;
    }

    .bayi-admin-app-card:hover,
    .bayi-admin-network-node:hover {
      border-color: #bfdbfe !important;
      box-shadow: 0 14px 34px rgba(15, 23, 42, .09) !important;
    }

    .bayi-admin-app-summary,
    .bayi-admin-network-summary {
      display: grid;
      grid-template-columns: minmax(0, 1.25fr) minmax(150px, .55fr) auto;
      gap: 14px;
      align-items: center;
    }

    .bayi-admin-network-summary {
      grid-template-columns: auto minmax(0, 1fr) auto;
    }

    .bayi-admin-app-detail-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 10px;
    }

    .bayi-admin-modal-backdrop {
      position: fixed;
      inset: 0;
      z-index: 9999;
      background: rgba(15, 23, 42, .66);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 18px;
      backdrop-filter: blur(6px);
    }

    .bayi-admin-modal {
      width: min(560px, 100%);
      max-height: calc(100vh - 36px);
      overflow: auto;
      border-radius: 24px;
      background: #fff;
      box-shadow: 0 30px 90px rgba(15, 23, 42, .35);
    }

    @media (max-width: 768px) {
      .admin-layout {
        display: flex !important;
        flex-direction: column !important;
      }

      .admin-card {
        width: 100% !important;
      }

      .bayi-admin-app-summary,
      .bayi-admin-network-summary {
        grid-template-columns: minmax(0, 1fr) auto;
      }

      .bayi-admin-app-summary > :nth-child(2) {
        display: none;
      }

      .bayi-admin-app-detail-grid {
        grid-template-columns: 1fr 1fr;
      }

      .bayi-admin-filterbar > button,
      .bayi-admin-actions > button,
      .bayi-admin-network-toolbar > * {
        flex: 1 1 145px;
      }

      .bayi-admin-network-children {
        margin-left: 10px !important;
        padding-left: 8px !important;
      }

      .bayi-admin-commission-row {
        grid-template-columns: 70px minmax(0, 1fr) 60px !important;
      }

      .bayi-admin-commission-row > :nth-child(4),
      .bayi-admin-commission-row > :nth-child(5) {
        grid-column: 2 / -1;
      }
    }

    @media (max-width: 480px) {
      .bayi-admin-app-detail-grid {
        grid-template-columns: 1fr;
      }

      .bayi-admin-app-summary,
      .bayi-admin-network-summary {
        gap: 8px;
      }

      .bayi-admin-modal-backdrop {
        padding: 8px;
      }

      .bayi-admin-modal {
        border-radius: 18px;
      }
    }
  `;
  document.head.appendChild(mobileStyle);

  return () => {
    document.head.removeChild(mobileStyle);
  };
}, []);

  /* LOGIN */
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


function kalanGun(bitisTarihi) {
  const bugun = new Date();
  const bitis = new Date(bitisTarihi);
  const fark = Math.ceil((bitis - bugun) / (1000 * 60 * 60 * 24));
  return fark;
}

function paketBitisTarihi(baslangicTarihi) {
  const baslangic = new Date(baslangicTarihi);
  baslangic.setDate(baslangic.getDate() + 365);
  return baslangic;
}

  /* DATA */
  const [kurumlar, setKurumlar] = useState([]);
  const [search, setSearch] = useState("");
  const [kurumTotal, setKurumTotal] = useState(0);
  const [kurumListTotal, setKurumListTotal] = useState(0);
  const [kurumPage, setKurumPage] = useState(1);
  const [kurumListOpen, setKurumListOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);


  /* FORM */
  const [ad, setAd] = useState("");
  const [code, setCode] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");


// ✅ YENİ EKLENENLER
const [kategoriId, setKategoriId] = useState("");
const [il, setIl] = useState("");
const [ilce, setIlce] = useState("");

// ✅ STATE'LER
const [cities, setCities] = useState([]);
const [districts, setDistricts] = useState([]);
const [city, setCity] = useState("");
const [district, setDistrict] = useState("");

/* ================= ŞUBE YÖNETİMİ ================= */
const [subelerByKurum, setSubelerByKurum] = useState({});
const [subeForms, setSubeForms] = useState({});
const [subeLinkForms, setSubeLinkForms] = useState({});
const [subeModeByKurum, setSubeModeByKurum] = useState({});
const [subeLoadingId, setSubeLoadingId] = useState(null);

/* ================= GENEL BAYİ DÜZENLEME ================= */
const [kurumEditOpenById, setKurumEditOpenById] = useState({});
const [kurumEditForms, setKurumEditForms] = useState({});
const [kurumEditLoadingId, setKurumEditLoadingId] = useState(null);


/* ================= REFERANS / SATIŞ İŞLEMLERİ ================= */
const [referansIslemlerByKurum, setReferansIslemlerByKurum] = useState({});
const [referansIslemForms, setReferansIslemForms] = useState({});
const [referansEditByKurum, setReferansEditByKurum] = useState({});

const [referansLoadingId, setReferansLoadingId] = useState(null);

// ✅ İLLERİ GETİR
useEffect(() => {
  fetch(`${API}/auth/locations/tr/cities`)
    .then(r => r.json())
    .then(d => setCities(normalizeLocationPayload(d, "city")))
    .catch(err => console.error("CITIES ERROR", err));
}, []);

// ✅ İLÇELERİ GETİR (il seçilince)
useEffect(() => {
  setDistrict("");

  if (!city) {
    setDistricts([]);
    return;
  }

  fetch(`${API}/auth/locations/tr/districts?city_id=${city}`)
    .then(r => r.json())
    .then(d => {
      const list = normalizeLocationPayload(d, "district");
      setDistricts(list);
    })
    .catch(err => console.error("DISTRICTS ERROR", err));
}, [city]);

// Başvurudan forma aktarılan ilçeyi, ilçe listesi yüklendikten sonra seç.
// Bu ayrı effect, pending değerini temizlerken seçilen ilçenin tekrar sıfırlanmasını önler.
useEffect(() => {
  if (!pendingDistrictFromBasvuru || !districts.length) return;

  const districtValue = String(pendingDistrictFromBasvuru).trim();
  const districtLower = districtValue.toLocaleLowerCase("tr-TR");
  const matched = districts.find((item) => (
    String(item.id || "").trim() === districtValue ||
    String(item.name || "").trim().toLocaleLowerCase("tr-TR") === districtLower
  ));

  if (matched) {
    setDistrict(String(matched.id));
  } else {
    console.warn("Başvurudan gelen ilçe listede eşleşmedi:", districtValue);
  }

  setPendingDistrictFromBasvuru("");
}, [districts, pendingDistrictFromBasvuru]);


  /* ================= LOGIN ================= */
const login = async () => {
  const cleanEmail = String(email || "").trim().toLowerCase();

  if (!ALLOWED_ADMIN_EMAILS.includes(cleanEmail)) {
    localStorage.removeItem("admin_token");
    setToken(null);
    setMessage({
      type: "error",
      text: "Bu admin paneline sadece yetkili hesaplar giriş yapabilir.",
    });
    return;
  }

  setLoading(true);
  setMessage(null);

  try {
    const res = await fetch(`${API}/giris`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: cleanEmail, password }),
    });

    const data = await res.json();

    if (res.ok && data?.token) {
      if (!isAllowedAdminToken(data.token)) {
        localStorage.removeItem("admin_token");
        setToken(null);
        setMessage({
          type: "error",
          text: "Bu hesap admin paneli için yetkili değil.",
        });
        return;
      }

      localStorage.setItem("admin_token", data.token);
      setToken(data.token);
    } else {
      localStorage.removeItem("admin_token");
      setToken(null);
      setMessage({
        type: "error",
        text: data?.message || "Giriş başarısız",
      });
    }
  } catch {
    localStorage.removeItem("admin_token");
    setToken(null);
    setMessage({ type: "error", text: "Sunucuya ulaşılamadı" });
  } finally {
    setLoading(false);
  }
};


  /* ================= LOGOUT ================= */
  const logout = () => {
    localStorage.removeItem("admin_token");
    setToken(null);
  };

  /* ================= LIST ================= */
  const fetchKurumlar = async ({
    page = kurumPage,
    term = search,
  } = {}) => {
    try {
      const safePage = Math.max(1, Number(page) || 1);
      const offset = (safePage - 1) * KURUM_PAGE_SIZE;
      const params = new URLSearchParams({
        limit: String(KURUM_PAGE_SIZE),
        offset: String(offset),
        bayi_only: "1",
      });

      if (String(term || "").trim()) {
        params.set("search", String(term).trim());
      }

      const res = await fetch(`${API}/admin/kurumlar?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const json = await readApiPayload(res);
      if (!res.ok) {
        throw makeRequestError(json, res, "Bayiler listelenemedi");
      }
      setKurumlar(json.data || []);
      setKurumListTotal(Number(json.total ?? json.data?.length ?? 0));
      setKurumTotal(
        Number(json.grand_total ?? json.bayi_total ?? json.total ?? json.data?.length ?? 0)
      );
    } catch (err) {
      setMessage({
        type: "error",
        text: err.message || "Bayiler listelenemedi",
      });
      setKurumlar([]);
      setKurumTotal(0);
      setKurumListTotal(0);
    }
  };


useEffect(() => {
  if (!token) return;

  if (!isAllowedAdminToken(token)) {
    localStorage.removeItem("admin_token");
    setToken(null);
    setMessage({
      type: "error",
      text: "Bu oturum admin paneli için yetkili değil.",
    });
  }
}, [token]);







useEffect(() => {
  if (token) {
    fetchPaketBasvurulari();
    fetchBayiBasvurulari();
    fetchOdemeTalepleri();
    fetchNetworkUsers();
  }
}, [token]);

useEffect(() => {
  if (!token) return;

  const timer = window.setTimeout(() => {
    fetchKurumlar({ page: kurumPage, term: search });
  }, 300);

  return () => window.clearTimeout(timer);
}, [token, kurumPage, search]);

/* ================= PAKET ONAYLA ================= */
const onaylaPaket = async (b) => {
  try {
const res = await fetch(`${API}/admin/paket/onayla/${b.id}`, {
  method: "POST",
  headers: {
    Authorization: `Bearer ${token}`
  }
});


    if (!res.ok) {
      alert("Paket onaylanamadı");
      return;
    }

    fetchPaketBasvurulari(); // tabloyu yenile
  } catch (err) {
    console.error("Onay hatası", err);
  }
};


/* ================= CREATE ================= */
const createKurum = async () => {
  if (!ad || !code || !shortCode || !adminEmail || !adminPassword) {
    setMessage({ type: "error", text: "Tüm alanlar zorunlu" });
    return;
  }

  if (!/^7\d{3}$/.test(code) || !/^7\d{3}$/.test(shortCode)) {
    setMessage({
      type: "error",
      text: "Kurum kodu 7000–7999 arasında olmalı",
    });
    return;
  }

  if (String(code).trim() !== String(shortCode).trim()) {
    setMessage({
      type: "error",
      text: "Kurum kodu ve short code aynı olmalı.",
    });
    return;
  }

  const cityId =
    city && Number.isFinite(Number(city)) ? Number(city) : null;

  const districtId =
    district && Number.isFinite(Number(district)) ? Number(district) : null;

  setLoading(true);
  setMessage(null);

  try {
    const res = await fetch(`${API}/admin/kurumlar`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ad,
        code,
        short_code: shortCode,
        email: adminEmail,
        sifre: adminPassword,

        kategori_id: kategoriId ? Number(kategoriId) : null,

        // Eski sistem
        il: cityId,
        ilce: districtId,

        // Backend farklı isim bekliyorsa da yakalasın
        il_id: cityId,
        ilce_id: districtId,
        city_id: cityId,
        district_id: districtId,
        sehir_id: cityId,
      }),
    });

    const data = await readApiPayload(res);

    if (!res.ok) {
      setMessage({
        type: "error",
        text: getApiErrorText(data, res, "Kayıt başarısız"),
      });
      return;
    }

    setMessage({
      type: "success",
      text: "✅ Bayi başarıyla oluşturuldu",
    });

    setAd("");
    setCode("");
    setShortCode("");
    setAdminEmail("");
    setAdminPassword("");
    setKategoriId("");
    setCity("");
    setDistrict("");
    setPendingDistrictFromBasvuru("");

    fetchKurumlar();
    fetchBayiBasvurulari();
    fetchNetworkUsers();
  } catch (err) {
    console.error("Bayi oluşturma hatası", err);
    setMessage({
      type: "error",
      text: `Bayi oluşturulamadı: ${err.message || "Sunucuya ulaşılamadı"}`,
    });
  } finally {
    setLoading(false);
  }
};


/* ================= ŞUBE FONKSİYONLARI ================= */
const getSubeForm = (oldId) => {
  return subeForms[oldId] || {
    sube_adi: "",
    sube_code: "",
    panel_email: "",
    panel_password: "",
    telefon: "",
    adres: "",
    access_scope: "branch",
  };
};

const getSubeLinkForm = (oldId) => {
  return subeLinkForms[oldId] || {
    kurum_code: "",
    panel_email: "",
  };
};

const getSubeMode = (oldId) => {
  return subeModeByKurum[oldId] || "create";
};

const setSubeMode = (oldId, mode) => {
  setSubeModeByKurum(prev => ({
    ...prev,
    [oldId]: mode,
  }));
};

const setSubeField = (oldId, field, value) => {
  setSubeForms(prev => ({
    ...prev,
    [oldId]: {
      ...getSubeForm(oldId),
      [field]: value,
    },
  }));
};

const setSubeLinkField = (oldId, field, value) => {
  setSubeLinkForms(prev => ({
    ...prev,
    [oldId]: {
      ...getSubeLinkForm(oldId),
      [field]: value,
    },
  }));
};

const fetchSubeler = async (oldId) => {
  if (!oldId) return;

  setSubeLoadingId(oldId);

  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/subeler`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Şubeler alınamadı",
      });
      return;
    }

    setSubelerByKurum(prev => ({
      ...prev,
      [oldId]: {
        kurum: data.kurum,
        data: data.data || [],
      },
    }));
  } catch (err) {
    console.error("Şubeler alınamadı", err);
    setMessage({
      type: "error",
      text: "Şubeler alınamadı",
    });
  } finally {
    setSubeLoadingId(null);
  }
};

const toggleMultiBranch = async (oldId, enabled) => {
  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/multi-branch`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ enabled }),
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Çok şubeli kullanım güncellenemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: data?.message || "Şube ayarı güncellendi",
    });

    await fetchSubeler(oldId);
    fetchKurumlar();
  } catch (err) {
    console.error("Çok şubeli kullanım hatası", err);
    setMessage({
      type: "error",
      text: "Çok şubeli kullanım güncellenemedi",
    });
  }
};

const createSube = async (oldId) => {
  const loadingKey = `create-${oldId}`;

  if (subeLoadingId === loadingKey) return;

  const form = getSubeForm(oldId);

  if (!form.sube_adi.trim()) {
    setMessage({
      type: "error",
      text: "Şube adı zorunlu",
    });
    return;
  }

if (!String(form.sube_code || "").trim()) {
  setMessage({
    type: "error",
    text: "Şube kodu zorunlu",
  });
  return;
}

if (!/^7\d{3}$/.test(String(form.sube_code || "").trim())) {
  setMessage({
    type: "error",
    text: "Şube kodu 7000–7999 arasında olmalı",
  });
  return;
}

if (String(form.panel_email || "").trim() && !String(form.panel_password || "").trim()) {
  setMessage({
    type: "error",
    text: "Panel e-postası girildiyse şifre de zorunlu",
  });
  return;
}

if (
  String(form.panel_password || "").trim() &&
  String(form.panel_password || "").trim().length < 6
) {
  setMessage({
    type: "error",
    text: "Şifre en az 6 karakter olmalı",
  });
  return;
}
setSubeLoadingId(loadingKey);

  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/subeler`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
     
body: JSON.stringify({
  sube_adi: form.sube_adi,
  sube_code: String(form.sube_code || "").trim(),
  panel_email: form.panel_email,
  panel_password: form.panel_password,
  sifre: form.panel_password,
  telefon: form.telefon,
  adres: form.adres,
  access_scope: form.access_scope || "branch",
}),
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Şube eklenemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: "✅ Şube eklendi",
    });

setSubeForms(prev => ({
  ...prev,
  [oldId]: {
    sube_adi: "",
    sube_code: "",
    panel_email: "",
    panel_password: "",
    telefon: "",
    adres: "",
    access_scope: "branch",
  },
}));

    fetchSubeler(oldId);
  } catch (err) {
    console.error("Şube ekleme hatası", err);
    setMessage({
      type: "error",
      text: "Şube eklenemedi",
    });
  } finally {
    setSubeLoadingId(null);
  }
};



const linkExistingKurumAsSube = async (oldId) => {
  if (subeLoadingId === `link-${oldId}`) return;

  const form = getSubeLinkForm(oldId);

  if (!String(form.kurum_code || "").trim()) {
    setMessage({
      type: "error",
      text: "Bağlanacak kurum kodu veya kurum ID zorunlu",
    });
    return;
  }

  setSubeLoadingId(`link-${oldId}`);

  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/subeler/bagla`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        kurum_code: String(form.kurum_code || "").trim(),
        panel_email: form.panel_email,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Mevcut kurum bağlanamadı",
      });
      return;
    }

    setMessage({
      type: "success",
      text: data?.message || "✅ Mevcut kurum şube olarak bağlandı",
    });

    setSubeLinkForms(prev => ({
      ...prev,
      [oldId]: {
        kurum_code: "",
        panel_email: "",
      },
    }));

    await fetchSubeler(oldId);
    fetchKurumlar();
  } catch (err) {
    console.error("Mevcut kurum bağlama hatası", err);
    setMessage({
      type: "error",
      text: "Mevcut kurum bağlanamadı",
    });
  } finally {
    setSubeLoadingId(null);
  }
};




const unlinkExistingKurumAsSube = async (oldId, linkedOldId) => {
  if (!oldId || !linkedOldId) {
    setMessage({
      type: "error",
      text: "Bağlantı ayrılacak kurum bilgisi bulunamadı",
    });
    return;
  }

  const loadingKey = `unlink-${oldId}-${linkedOldId}`;

  if (subeLoadingId === loadingKey) return;

  if (!window.confirm("Bu bağlı kurumu merkezden ayırmak istiyor musun?")) {
    return;
  }

  setSubeLoadingId(loadingKey);

  try {
    const res = await fetch(
      `${API}/admin/kurumlar/${oldId}/subeler/${linkedOldId}/baglantiyi-ayir`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Kurum bağlantısı ayrılamadı",
      });
      return;
    }

    setMessage({
      type: "success",
      text: data?.message || "✅ Kurum bağlantısı ayrıldı",
    });

    await fetchSubeler(oldId);
    fetchKurumlar();
  } catch (err) {
    console.error("Kurum bağlantısı ayırma hatası", err);
    setMessage({
      type: "error",
      text: "Kurum bağlantısı ayrılamadı",
    });
  } finally {
    setSubeLoadingId(null);
  }
};




const passiveSube = async (oldId, subeId) => {
  if (!window.confirm("Bu şubeyi pasifleştirmek istiyor musun?")) return;

  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/subeler/${subeId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Şube pasifleştirilemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: "Şube pasifleştirildi",
    });

    fetchSubeler(oldId);
  } catch (err) {
    console.error("Şube pasifleştirme hatası", err);
    setMessage({
      type: "error",
      text: "Şube pasifleştirilemedi",
    });
  }
};


/* ================= REFERANS / SATIŞ İŞLEMİ FONKSİYONLARI ================= */
const getReferansForm = (oldId) => {
  return referansIslemForms[oldId] || {
    referans: "",
    firma_adi: "",
    islem_tipi: "satis",
    satilan_urun: "",
    satis_tutari: "",

    hakedis_kademe: "1",
    hakedis_1_oran: DOGRUDAN_BAYI_ORANI,
    hakedis_2_oran: UST_SPONSOR_ORANI,
    hakedis_3_oran: 0,

    sozlesme_baslangic: "",
    sozlesme_bitis: "",
    anlasma_notu: "",
  };
};

const setReferansField = (oldId, field, value) => {
  const current = getReferansForm(oldId);

  const nextForm = {
    ...current,
    [field]: value,
  };

  if (field === "sozlesme_baslangic") {
    nextForm.sozlesme_bitis = addOneYear(value);
  }

  setReferansIslemForms(prev => ({
    ...prev,
    [oldId]: nextForm,
  }));
};

const resetReferansForm = (oldId) => {
  setReferansIslemForms(prev => ({
    ...prev,
    [oldId]: {
      referans: "",
      firma_adi: "",
      islem_tipi: "satis",
      satilan_urun: "",
      satis_tutari: "",

      hakedis_kademe: "1",
      hakedis_1_oran: DOGRUDAN_BAYI_ORANI,
      hakedis_2_oran: UST_SPONSOR_ORANI,
      hakedis_3_oran: 0,

      sozlesme_baslangic: "",
      sozlesme_bitis: "",
      anlasma_notu: "",
    },
  }));

  setReferansEditByKurum(prev => ({
    ...prev,
    [oldId]: null,
  }));
};

const fetchReferansIslemler = async (oldId) => {
  if (!oldId) return;

  setReferansLoadingId(`list-${oldId}`);

  try {
    const res = await fetch(`${API}/admin/bayilik/islemler/${oldId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setReferansIslemlerByKurum(prev => ({
        ...prev,
        [oldId]: [],
      }));

      if (res.status !== 404) {
        setMessage({
          type: "error",
          text: data?.message || "Referans / satış işlemleri alınamadı",
        });
      }

      return;
    }

    setReferansIslemlerByKurum(prev => ({
      ...prev,
      [oldId]: data.data || data.islemler || [],
    }));
  } catch (err) {
    console.error("Referans / satış işlemleri alınamadı", err);
    setMessage({
      type: "error",
      text: "Referans / satış işlemleri alınamadı",
    });
  } finally {
    setReferansLoadingId(null);
  }
};

const saveReferansIslem = async (oldId, kurum) => {
  const form = getReferansForm(oldId);
  const editId = referansEditByKurum[oldId];

  if (!String(form.referans || "").trim()) {
    setMessage({
      type: "error",
      text: "Referans / satışçı zorunlu",
    });
    return;
  }

  if (!String(form.firma_adi || "").trim()) {
    setMessage({
      type: "error",
      text: "Firma adı zorunlu",
    });
    return;
  }

  if (!String(form.satilan_urun || "").trim()) {
    setMessage({
      type: "error",
      text: "Satılan ürün / paket zorunlu",
    });
    return;
  }

  const payload = {
    kurum_old_id: oldId,
    kurum_id: kurum?.id || null,
    kurum_code: kurum?.code || "",
    kurum_short_code: kurum?.short_code || "",

    referans: String(form.referans || "").trim(),
    firma_adi: String(form.firma_adi || "").trim(),
    islem_tipi: form.islem_tipi || "satis",
    satilan_urun: String(form.satilan_urun || "").trim(),

    satis_tutari: numValue(form.satis_tutari),

    hakedis_kademe: "1",
    hakedis_1_oran: DOGRUDAN_BAYI_ORANI,
    hakedis_2_oran: UST_SPONSOR_ORANI,
    hakedis_3_oran: 0,
    hakedis_orani: DOGRUDAN_BAYI_ORANI,
    hakedis_tutari: hesaplaHakedis(
      form.satis_tutari,
      DOGRUDAN_BAYI_ORANI
    ),

    anlasma_tarihi: form.sozlesme_baslangic || null,
    sozlesme_baslangic: form.sozlesme_baslangic || null,
    sozlesme_bitis: form.sozlesme_bitis || addOneYear(form.sozlesme_baslangic) || null,

    anlasma_notu: String(form.anlasma_notu || "").trim(),
  };

  const loadingKey = editId ? `update-${editId}` : `create-${oldId}`;
  setReferansLoadingId(loadingKey);

  try {
    const res = await fetch(
      editId
        ? `${API}/admin/bayilik/islemler/${editId}`
        : `${API}/admin/bayilik/islemler`,
      {
        method: editId ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "İşlem kaydı kaydedilemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: editId
        ? "✅ İşlem kaydı güncellendi"
        : "✅ İşlem kaydı kaydedildi",
    });

    resetReferansForm(oldId);
    await fetchReferansIslemler(oldId);
  } catch (err) {
    console.error("Referans / satış işlem kayıt hatası", err);
    setMessage({
      type: "error",
      text: "İşlem kaydı kaydedilemedi",
    });
  } finally {
    setReferansLoadingId(null);
  }
};

const editReferansIslem = (oldId, row) => {
  setReferansEditByKurum(prev => ({
    ...prev,
    [oldId]: row.id,
  }));

  setReferansIslemForms(prev => ({
    ...prev,
    [oldId]: {
      referans: row.referans || "",
      firma_adi: row.firma_adi || "",
      islem_tipi: row.islem_tipi || "satis",
      satilan_urun: row.satilan_urun || "",
      satis_tutari: row.satis_tutari || "",

      hakedis_kademe: "1",
      hakedis_1_oran: DOGRUDAN_BAYI_ORANI,
      hakedis_2_oran: UST_SPONSOR_ORANI,
      hakedis_3_oran: 0,

      sozlesme_baslangic: row.sozlesme_baslangic
        ? String(row.sozlesme_baslangic).slice(0, 10)
        : "",

      sozlesme_bitis: row.sozlesme_bitis
        ? String(row.sozlesme_bitis).slice(0, 10)
        : addOneYear(row.sozlesme_baslangic),

      anlasma_notu: row.anlasma_notu || "",
    },
  }));
};

const deleteReferansIslem = async (oldId, id) => {
  if (!id) return;

  if (!window.confirm("Bu işlem kaydını silmek istiyor musun?")) return;

  setReferansLoadingId(`delete-${id}`);

  try {
    const res = await fetch(`${API}/admin/bayilik/islemler/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "İşlem kaydı silinemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: "✅ İşlem kaydı silindi",
    });

    resetReferansForm(oldId);
    await fetchReferansIslemler(oldId);
  } catch (err) {
    console.error("Referans / satış işlem silme hatası", err);
    setMessage({
      type: "error",
      text: "İşlem kaydı silinemedi",
    });
  } finally {
    setReferansLoadingId(null);
  }
};



const formatSimpleDate = (value) => {








  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("tr-TR");
};

/* ================= GENEL BAYİ DÜZENLEME FONKSİYONLARI ================= */
const getKurumEditForm = (oldId) => {
  return kurumEditForms[oldId] || {
    ad: "",
    code: "",
    short_code: "",
    kullanici_adi: "",
    email: "",
    sifre: "",
    referans_code: "",
    referans_adi: "",
    original_code: "",
    application_id: null,
  };
};

const openKurumEdit = (k) => {
  const oldId = k.old_id;
  const networkMatch = uniqueNetworkRows.find((row) => {
    const nodeCode = getNetworkNodeCode(row);
    return (
      nodeCode === String(k.code || "").trim() ||
      nodeCode === String(k.short_code || "").trim() ||
      (
        row.email &&
        k.email &&
        String(row.email).toLowerCase() === String(k.email).toLowerCase()
      )
    );
  });

  setKurumEditOpenById(prev => ({
    ...prev,
    [oldId]: !prev[oldId],
  }));

  setKurumEditForms(prev => ({
    ...prev,
    [oldId]: {
      ad: k.ad || "",
      code: k.code || "",
      short_code: k.short_code || "",
      kullanici_adi:
        k.kullanici_adi ||
        k.panel_kullanici_adi ||
        k.admin_adi ||
        k.ad ||
        "",
email:
  k.email ||
  k.admin_email ||
  k.panel_email ||
  k.user_email ||
  k.kullanici_email ||
  k.admin_mail ||
  k.mail ||
  "",
      sifre: "",
      referans_code:
        networkMatch?.ref_code ||
        k.referans_code ||
        k.ref_code ||
        k.davet_eden_code ||
        "",
      referans_adi:
        networkMatch?.davet_eden_adi ||
        k.referans_adi ||
        "",
      original_code: k.code || "",
      application_id:
        networkMatch?.move_application_id ||
        k.bayilik_davet_id ||
        k.application_id ||
        null,
    },
  }));
};

const setKurumEditField = (oldId, field, value) => {
  setKurumEditForms(prev => ({
    ...prev,
    [oldId]: {
      ...getKurumEditForm(oldId),
      [field]: value,
    },
  }));
};

const cancelKurumEdit = (oldId) => {
  setKurumEditOpenById(prev => ({
    ...prev,
    [oldId]: false,
  }));

  setKurumEditForms(prev => ({
    ...prev,
    [oldId]: {
      ad: "",
      code: "",
      short_code: "",
      kullanici_adi: "",
      email: "",
      sifre: "",
      referans_code: "",
      referans_adi: "",
      original_code: "",
      application_id: null,
    },
  }));
};

const saveKurumEdit = async (oldId) => {
  const form = getKurumEditForm(oldId);

  if (!String(form.ad || "").trim()) {
    setMessage({ type: "error", text: "İşletme adı zorunlu" });
    return;
  }

  if (!/^7\d{3}$/.test(String(form.code || "").trim())) {
    setMessage({ type: "error", text: "Kurum kodu 7000–7999 arasında olmalı" });
    return;
  }

  if (!/^7\d{3}$/.test(String(form.short_code || "").trim())) {
    setMessage({ type: "error", text: "Short code 7000–7999 arasında olmalı" });
    return;
  }

  if (!String(form.email || "").trim()) {
    setMessage({ type: "error", text: "Panel e-posta zorunlu" });
    return;
  }

  if (!String(form.kullanici_adi || "").trim()) {
    setMessage({ type: "error", text: "Panel kullanıcı adı zorunlu" });
    return;
  }

  const cleanReferansCode = String(form.referans_code || "").trim();
  if (cleanReferansCode && !/^7\d{3}$/.test(cleanReferansCode)) {
    setMessage({
      type: "error",
      text: "Üst sponsor / referans kodu 7000–7999 arasında olmalı",
    });
    return;
  }

  if (cleanReferansCode === String(form.code || "").trim()) {
    setMessage({
      type: "error",
      text: "Bir bayi kendi referans koduna bağlanamaz",
    });
    return;
  }

  if (
    String(form.sifre || "").trim() &&
    String(form.sifre || "").trim().length < 6
  ) {
    setMessage({ type: "error", text: "Yeni şifre en az 6 karakter olmalı" });
    return;
  }

  setKurumEditLoadingId(oldId);

  try {
    const payload = {
      ad: String(form.ad || "").trim(),
      code: String(form.code || "").trim(),
      short_code: String(form.short_code || "").trim(),
      kullanici_adi: String(form.kullanici_adi || "").trim(),
      email: String(form.email || "").trim(),
      referans_code: cleanReferansCode || null,
      original_code: String(form.original_code || "").trim(),
      application_id: form.application_id || null,
    };

    if (String(form.sifre || "").trim()) {
      payload.sifre = String(form.sifre || "").trim();
      payload.password = String(form.sifre || "").trim();
      payload.admin_password = String(form.sifre || "").trim();
    }

    const res = await fetch(`${API}/admin/bayilik/bayiler/${oldId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await readApiPayload(res);

    if (!res.ok) {
      const rawServerMessage = String(data?.message || data?.error || "");
      setMessage({
        type: "error",
        text:
          res.status === 404 && /Cannot\s+PUT/i.test(rawServerMessage)
            ? "Sunucuda yeni bayilik.js düzenleme route'u aktif değil. bayilik.js dosyasını backend'e koyup PM2 sürecini yeniden başlatın."
            : getApiErrorText(data, res, "Bayi bilgileri güncellenemedi"),
      });
      return;
    }

    setMessage({
      type: "success",
      text: data?.message || "✅ Bayi bilgileri ve referans bağlantısı güncellendi",
    });

    cancelKurumEdit(oldId);
    fetchKurumlar();
  } catch (err) {
    console.error("Bayi düzenleme hatası", err);
    setMessage({
      type: "error",
      text: err.message || "Bayi bilgileri güncellenemedi",
    });
  } finally {
    setKurumEditLoadingId(null);
  }
};

const apiRequestFallback = async (requests = []) => {
  let lastData = null;
  let lastResponse = null;

  for (const req of requests) {
    const res = await fetch(req.url, {
      method: req.method || "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...(req.headers || {}),
      },
      body: req.body ? JSON.stringify(req.body) : undefined,
    });

    const data = await readApiPayload(res);
    lastData = data;
    lastResponse = res;

    if (res.ok) {
      return data;
    }
  }

  throw makeRequestError(
    lastData || {},
    lastResponse,
    "İşlem tamamlanamadı"
  );
};

/* ================= DELETE / PASİFLEŞTİR ================= */
const deleteKurum = async (kurumOrOldId) => {
  const oldId =
    typeof kurumOrOldId === "object"
      ? kurumOrOldId.old_id || kurumOrOldId.id || kurumOrOldId.kurum_id
      : kurumOrOldId;

  if (!oldId) {
    setMessage({ type: "error", text: "Kurum ID bulunamadı" });
    return;
  }

  if (
    !window.confirm(
      "Bu bayiyi silmek/pasifleştirmek istiyor musun? Bağlı kayıt varsa sistem güvenli şekilde pasifleştirmeyi dener."
    )
  ) {
    return;
  }

  setLoading(true);
  setMessage(null);

  try {
    await apiRequestFallback([
      {
        url: `${API}/admin/kurumlar/${oldId}`,
        method: "DELETE",
      },
      {
        url: `${API}/admin/kurumlar/${oldId}/durum`,
        method: "PATCH",
        body: {
          aktif: false,
          durum: "pasif",
        },
      },
      {
        url: `${API}/admin/kurumlar/${oldId}`,
        method: "PUT",
        body: {
          aktif: false,
          durum: "pasif",
        },
      },
    ]);

    setMessage({
      type: "success",
      text: "✅ Bayi silindi veya güvenli şekilde pasifleştirildi",
    });

    await fetchKurumlar();
    await fetchBayiBasvurulari();
    await fetchNetworkUsers();
  } catch (err) {
    console.error("Bayi silme/pasifleştirme hatası", err);
    setMessage({
      type: "error",
      text: err.message || "Bayi silinemedi/pasifleştirilemedi",
    });
  } finally {
    setLoading(false);
  }
};


/* ================= BAYİ BAŞVURU İŞLEMLERİ ================= */
const aktarBayiBasvuruToCreateForm = (b) => {
  if (!b) return;

  const basvuruCode = String(
    b.talep_code ||
    b.talep_short_code ||
    ""
  ).trim();

  setAd(b.firma_adi || "");
  setCode(basvuruCode);
  setShortCode(basvuruCode);
  setAdminEmail(b.email || "");
  setAdminPassword("");

  setKategoriId(b.kategori_id ? String(b.kategori_id) : "");

const basvuruIl = pickFirst(b, [
  "il",
  "il_id",
  "city_id",
  "sehir_id",
  "province_id",
], "");

const basvuruIlce = pickFirst(b, [
  "ilce",
  "ilce_id",
  "district_id",
  "county_id",
  "town_id",
  "ilce_adi",
  "district_name",
], "");

if (basvuruIl) {
  setCity(String(basvuruIl));
} else {
  setCity("");
}

if (basvuruIlce) {
  setPendingDistrictFromBasvuru(String(basvuruIlce));
} else {
  setDistrict("");
  setPendingDistrictFromBasvuru("");
}

  setMessage({
    type: "success",
    text: `✅ ${b.firma_adi || "Başvuru"} yeni bayi formuna aktarıldı. Şifreyi yazıp “Bayiyi Kaydet” butonuna basabilirsin.`,
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const updateBayiBasvuruDurum = async (b, durum) => {
  if (!b?.id) return;

  const label = getBayiBasvuruDurumText(durum);

  setApprovalDialog({ b, durum, label });
  setApprovalConfirmed(false);
  setApprovalNote("");
};

const closeApprovalDialog = () => {
  if (bayiBasvuruLoadingId) return;
  setApprovalDialog(null);
  setApprovalConfirmed(false);
  setApprovalNote("");
};

const confirmBayiBasvuruDurum = async () => {
  const b = approvalDialog?.b;
  const durum = approvalDialog?.durum;
  const label = approvalDialog?.label || getBayiBasvuruDurumText(durum);

  if (!b?.id || !durum) return;

  if (!approvalConfirmed) {
    setMessage({
      type: "error",
      text: "İşlemi tamamlamak için manuel onay kutusunu işaretlemelisin.",
    });
    return;
  }

  setBayiBasvuruLoadingId(`${durum}-${b.id}`);
  setMessage(null);

  try {
    const payload = {
      durum,
      manuel_onay: true,
      onay_notu: String(approvalNote || "").trim(),
    };

    // Aktif bayi yapılacaksa, daha önce oluşturulan kurum kodu ile bağlamayı dener.
    // Kurum henüz oluşturulmadıysa backend uyarı döndürür.
    if (durum === "aktif_bayi") {
      payload.kurum_code =
        b.yeni_kurum_code ||
        b.talep_code ||
        b.talep_short_code ||
        "";
    }

    const res = await fetch(`${API}/admin/bayilik/davetler/${b.id}/durum`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await readApiPayload(res);

    if (!res.ok) {
      throw makeRequestError(
        data,
        res,
        "Bayi başvuru durumu güncellenemedi"
      );
    }

    setMessage({
      type: "success",
      text: `✅ ${b.firma_adi || b.ad_soyad || "Başvuru"} için manuel işlem tamamlandı: ${label}`,
    });

    await fetchBayiBasvurulari();
    await fetchNetworkUsers();
    setApprovalDialog(null);
    setApprovalConfirmed(false);
    setApprovalNote("");
  } catch (err) {
    console.error("Bayi başvuru durum hatası", err);
    setMessage({
      type: "error",
      text: err.message || "Bayi başvuru durumu güncellenemedi",
    });
  } finally {
    setBayiBasvuruLoadingId(null);
  }
};

const correctBayiBasvuruReference = async (b) => {
  const newRefCode = String(
    bayiBasvuruRefDraft[b.id] ?? b.ref_code ?? ""
  ).trim();

  if (!/^7\d{3}$/.test(newRefCode)) {
    setMessage({
      type: "error",
      text: "Yeni üst sponsor kodu 7000–7999 arasında olmalıdır.",
    });
    return;
  }

  if (newRefCode === String(b.ref_code || "").trim()) {
    setMessage({ type: "error", text: "Yeni referans kodu mevcut kodla aynı." });
    return;
  }

  const approved = window.confirm(
    `${b.firma_adi || b.ad_soyad || "Bu kayıt"} için üst sponsor ${b.ref_code || "-"} yerine ${newRefCode} olarak değiştirilsin mi? Alt ekip bağlantıları korunacaktır.`
  );
  if (!approved) return;

  setBayiBasvuruLoadingId(`referans-${b.id}`);
  try {
    const res = await fetch(`${API}/admin/bayilik/network/tasi`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        application_id: b.id,
        yeni_parent_code: newRefCode,
      }),
    });

    const data = await readApiPayload(res);
    if (!res.ok) {
      throw makeRequestError(data, res, "Referans kodu düzeltilemedi");
    }

    setMessage({
      type: "success",
      text: data?.message || `Referans kodu ${newRefCode} olarak güncellendi.`,
    });
    setBayiBasvuruRefDraft((prev) => {
      const next = { ...prev };
      delete next[b.id];
      return next;
    });
    await fetchBayiBasvurulari();
    await fetchNetworkUsers();
  } catch (err) {
    setMessage({
      type: "error",
      text: err.message || "Referans kodu düzeltilemedi",
    });
  } finally {
    setBayiBasvuruLoadingId(null);
  }
};




/* ================= NETWORK / BAŞVURU PASİFLEŞTİR ================= */
const deactivateNetworkUser = async (row) => {
  const userId = typeof row === "object" ? row.id : row;
  const source = typeof row === "object" ? row.source : "network";

  if (!userId) {
    setMessage({ type: "error", text: "Kullanıcı ID bulunamadı" });
    return;
  }

  if (
    !window.confirm(
      "Bu kişiyi listeden çıkarmak/pasifleştirmek istiyor musun?"
    )
  ) {
    return;
  }

  setMessage(null);

  try {
    if (source === "bayi_basvuru") {
      await apiRequestFallback([
        {
          url: `${API}/admin/bayilik/davetler/${userId}/durum`,
          method: "PATCH",
          body: {
            durum: "pasif",
            bayi_aktif: false,
            aktif: false,
          },
        },
        {
          url: `${API}/admin/bayilik/davetler/${userId}/durum`,
          method: "PATCH",
          body: {
            durum: "reddedildi",
            bayi_aktif: false,
            aktif: false,
          },
        },
      ]);
    } else {
      await apiRequestFallback([
        {
          url: `${API}/admin/network/deactivate-user/${userId}`,
          method: "POST",
          body: {
            status: "left",
            network_status: "left",
            aktif: false,
          },
        },
        {
          url: `${API}/admin/network/remove-user/${userId}`,
          method: "POST",
          body: {
            status: "left",
            aktif: false,
          },
        },
        {
          url: `${API}/admin/network/users/${userId}`,
          method: "DELETE",
        },
      ]);
    }

    setMessage({
      type: "success",
      text: "✅ Kişi listeden çıkarıldı veya pasifleştirildi",
    });

    await fetchNetworkUsers();
    await fetchBayiBasvurulari();
  } catch (err) {
    console.error("Network kullanıcı pasifleştirme hatası", err);
    setMessage({
      type: "error",
      text: err.message || "Network kullanıcısı çıkarılamadı",
    });
  }
};

/* ================= NETWORK AĞAÇ / EKİP TAŞIMA ================= */
const getNetworkDescendantKeys = (row) => {
  const descendants = new Set();
  const startCode = getNetworkNodeCode(row);

  if (!startCode) return descendants;

  const visit = (parentCode) => {
    uniqueNetworkRows
      .filter((candidate) => String(candidate.ref_code || "").trim() === parentCode)
      .forEach((child) => {
        const key = getNetworkRowKey(child);
        if (descendants.has(key)) return;
        descendants.add(key);
        const childCode = getNetworkNodeCode(child);
        if (childCode) visit(childCode);
      });
  };

  visit(startCode);
  return descendants;
};

const moveNetworkTeam = async (row, target) => {
  if (!row || !target) {
    setMessage({ type: "error", text: "Taşınacak bayi ve yeni üst bayi seçilmelidir." });
    return;
  }

  const rowKey = getNetworkRowKey(row);
  const targetKey = getNetworkRowKey(target);
  const rowCode = getNetworkNodeCode(row);
  const targetCode = getNetworkNodeCode(target);

  if (!rowCode || !targetCode) {
    setMessage({
      type: "error",
      text: "Taşıma için her iki bayinin de kurum/referans kodu bulunmalıdır.",
    });
    return;
  }

  if (rowKey === targetKey || rowCode === targetCode) {
    setMessage({ type: "error", text: "Bir bayi kendi altına taşınamaz." });
    return;
  }

  const descendants = getNetworkDescendantKeys(row);
  if (descendants.has(targetKey)) {
    setMessage({
      type: "error",
      text: "Döngü engellendi: Bir bayi kendi alt ekibindeki kişinin altına taşınamaz.",
    });
    return;
  }

  const teamCount = descendants.size;
  const rowName = row.kurum_adi || row.ad_soyad || rowCode;
  const targetName = target.kurum_adi || target.ad_soyad || targetCode;

  if (
    !window.confirm(
      `“${rowName}” ve bağlı ${teamCount} ekip kaydı “${targetName}” altına taşınacak. Bu değişikliği onaylıyor musun?`
    )
  ) {
    return;
  }

  setNetworkMoveLoadingKey(rowKey);
  setMessage(null);

  try {
    const res = await fetch(`${API}/admin/bayilik/network/tasi`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        node_id: row.id || row.user_id || row.kurum_id || null,
        application_id: row.move_application_id || null,
        node_source: row.source || "network",
        node_code: rowCode,
        node_email: row.email || "",
        mevcut_parent_code: row.ref_code || "",
        yeni_parent_id: target.id || target.user_id || target.kurum_id || null,
        yeni_parent_code: targetCode,
        yeni_parent_adi: target.kurum_adi || target.ad_soyad || "",
      }),
    });

    const data = await readApiPayload(res);
    if (!res.ok) {
      throw makeRequestError(data, res, "Bayi ekibi taşınamadı");
    }

    setMessage({
      type: "success",
      text: data?.message || `✅ ${rowName} ve ekibi ${targetName} altına taşındı.`,
    });
    setNetworkMoveTargetByKey((prev) => ({ ...prev, [rowKey]: "" }));
    await fetchBayiBasvurulari();
    await fetchNetworkUsers();
  } catch (err) {
    console.error("Network ekip taşıma hatası", err);
    setMessage({
      type: "error",
      text: err.message || "Bayi ekibi taşınamadı",
    });
  } finally {
    setNetworkMoveLoadingKey("");
    setDraggedNetworkKey("");
    setNetworkDropKey("");
  }
};

const renderNetworkNode = (node, depth = 0) => {
  const key = getNetworkRowKey(node);
  const isExpanded = networkExpandedByKey[key] ?? false;
  const isMoving = networkMoveLoadingKey === key;
  const isDropTarget = networkDropKey === key && draggedNetworkKey !== key;
  const descendants = getNetworkDescendantKeys(node);
  const selectedTargetKey = networkMoveTargetByKey[key] || "";
  const selectedTarget = uniqueNetworkRows.find(
    (candidate) => getNetworkRowKey(candidate) === selectedTargetKey
  );
  const availableTargets = uniqueNetworkRows.filter((candidate) => {
    const candidateKey = getNetworkRowKey(candidate);
    return (
      candidateKey !== key &&
      !descendants.has(candidateKey) &&
      !!getNetworkNodeCode(candidate)
    );
  });

  return (
    <div key={key} style={{ marginTop: depth ? 9 : 0 }}>
      <div
        className="bayi-admin-network-node"
        draggable={!!getNetworkNodeCode(node) && !isMoving}
        onDragStart={(event) => {
          setDraggedNetworkKey(key);
          event.dataTransfer.effectAllowed = "move";
          event.dataTransfer.setData("text/plain", key);
        }}
        onDragEnd={() => {
          setDraggedNetworkKey("");
          setNetworkDropKey("");
        }}
        onDragOver={(event) => {
          if (!draggedNetworkKey || draggedNetworkKey === key) return;
          event.preventDefault();
          event.dataTransfer.dropEffect = "move";
          setNetworkDropKey(key);
        }}
        onDragLeave={() => {
          if (networkDropKey === key) setNetworkDropKey("");
        }}
        onDrop={(event) => {
          event.preventDefault();
          const sourceKey = event.dataTransfer.getData("text/plain") || draggedNetworkKey;
          const source = uniqueNetworkRows.find(
            (candidate) => getNetworkRowKey(candidate) === sourceKey
          );
          setNetworkDropKey("");
          if (source) moveNetworkTeam(source, node);
        }}
        style={{
          border: `1px solid ${isDropTarget ? "#2563eb" : "#dbe4f0"}`,
          borderRadius: 16,
          background: isDropTarget ? "#eff6ff" : "#fff",
          boxShadow: isDropTarget
            ? "0 0 0 4px rgba(37,99,235,.12)"
            : "0 8px 22px rgba(15,23,42,.05)",
          overflow: "hidden",
          opacity: isMoving ? 0.65 : 1,
        }}
      >
        <div
          className="bayi-admin-network-summary"
          style={{ padding: "12px 13px", cursor: "grab" }}
        >
          <button
            type="button"
            onClick={() =>
              setNetworkExpandedByKey((prev) => ({ ...prev, [key]: !isExpanded }))
            }
            aria-label={isExpanded ? "Ekibi kapat" : "Ekibi aç"}
            style={{
              width: 36,
              height: 36,
              borderRadius: 11,
              border: "1px solid #cbd5e1",
              background: isExpanded ? "#0f3a67" : "#f8fafc",
              color: isExpanded ? "#fff" : "#334155",
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            {node.children.length ? (isExpanded ? "−" : "+") : "•"}
          </button>

          <div style={{ minWidth: 0 }}>
            <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
              <b style={{ color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis" }}>
                {node.kurum_adi || node.ad_soyad || "İsimsiz kayıt"}
              </b>
              <span style={getBayiBasvuruDurumStyle(node.network_status)}>
                {getBayiBasvuruDurumText(node.network_status)}
              </span>
            </div>
            <div style={{ color: "#64748b", fontSize: 12, marginTop: 4, lineHeight: 1.5 }}>
              Kod: <b>{getNetworkNodeCode(node) || "-"}</b> · Üst kod: <b>{node.ref_code || "-"}</b>
              {node.davet_eden_adi ? ` · ${node.davet_eden_adi}` : ""}
            </div>
            <div style={{ color: "#94a3b8", fontSize: 11, marginTop: 2 }}>
              {node.email || node.telefon || "İletişim bilgisi yok"} · Alt ekip: {descendants.size}
            </div>
          </div>

          <div style={{ textAlign: "right" }}>
            <span style={{
              display: "inline-flex",
              padding: "6px 9px",
              borderRadius: 999,
              background: "#f1f5f9",
              color: "#475569",
              fontSize: 11,
              fontWeight: 900,
            }}>
              ↕ Ekibiyle Taşı
            </span>
          </div>
        </div>

        {isExpanded && (
          <div style={{ padding: "0 13px 13px", borderTop: "1px solid #eef2f7" }}>
            <div
              className="bayi-admin-network-toolbar"
              style={{ paddingTop: 12 }}
            >
              <select
                style={{ ...styles.input, margin: 0, flex: "1 1 240px" }}
                value={selectedTargetKey}
                onChange={(event) =>
                  setNetworkMoveTargetByKey((prev) => ({
                    ...prev,
                    [key]: event.target.value,
                  }))
                }
              >
                <option value="">Yeni üst bayi seç...</option>
                {availableTargets.map((target) => {
                  const targetKey = getNetworkRowKey(target);
                  return (
                    <option key={targetKey} value={targetKey}>
                      {target.kurum_adi || target.ad_soyad || "Kayıt"} ({getNetworkNodeCode(target)})
                    </option>
                  );
                })}
              </select>

              <button
                type="button"
                disabled={!selectedTarget || isMoving}
                onClick={() => moveNetworkTeam(node, selectedTarget)}
                style={{
                  border: "none",
                  borderRadius: 12,
                  padding: "11px 14px",
                  background: selectedTarget ? "#2563eb" : "#cbd5e1",
                  color: "#fff",
                  fontWeight: 900,
                  cursor: selectedTarget ? "pointer" : "not-allowed",
                }}
              >
                {isMoving ? "Taşınıyor..." : "Seçilen Bayinin Altına Taşı"}
              </button>

              <button
                type="button"
                onClick={() => deactivateNetworkUser(node)}
                style={{
                  border: "1px solid #fecaca",
                  borderRadius: 12,
                  padding: "10px 13px",
                  background: "#fff1f2",
                  color: "#b91c1c",
                  fontWeight: 900,
                  cursor: "pointer",
                }}
              >
                Pasifleştir
              </button>
            </div>
          </div>
        )}
      </div>

      {isExpanded && node.children.length > 0 && (
        <div
          className="bayi-admin-network-children"
          style={{
            marginLeft: 22,
            paddingLeft: 14,
            borderLeft: "2px solid #bfdbfe",
          }}
        >
          {node.children.map((child) => renderNetworkNode(child, depth + 1))}
        </div>
      )}
    </div>
  );
};

  /* ================= LOGIN UI ================= */
  if (!token) {
    return (
      <div style={styles.loginPage}>
        <div style={styles.loginCard}>
          <h2>BAYİ YÖNETİMİ</h2>
          <input style={styles.input} placeholder="E-posta" onChange={e => setEmail(e.target.value)} />
          <input style={styles.input} type="password" placeholder="Şifre" onChange={e => setPassword(e.target.value)} />
          <button style={styles.primaryBtn} onClick={login}>
            {loading ? "Bekleyin..." : "Giriş Yap"}
          </button>
        </div>
      </div>
    );
  }

  /* ================= FILTER ================= */
const filtered = kurumlar
  // 🔴 PANEL USER SATIRLARINI AT
  .filter(k => k.code && k.short_code);

const kurumTotalPages = Math.max(
  1,
  Math.ceil(kurumListTotal / KURUM_PAGE_SIZE)
);

const basvuruNetworkRows = bayiBasvurulari.map(b => ({
  ...b,
  id: b.id,
  ad_soyad: b.ad_soyad || "",
  kurum_adi: b.firma_adi || "",
  email: b.email || "",
  telefon: b.telefon || "",
  ref_code: b.ref_code || b.referans_code || "",
  davet_eden_adi: b.davet_eden_adi || b.referans_adi || "",
  network_status: b.durum || "kayit_bekliyor",
  talep_code: b.talep_code || "",
  talep_short_code: b.talep_short_code || "",
  node_code:
    b.yeni_kurum_code ||
    b.yeni_kurum_short_code ||
    b.talep_code ||
    b.talep_short_code ||
    "",
  source: "bayi_basvuru",
  move_application_id: b.id,
}));

const networkRowMap = new Map();

[...networkUsers, ...basvuruNetworkRows].forEach((row) => {
  const nodeCode = getNetworkNodeCode(row);
  const identity =
    nodeCode ||
    String(row.email || "").trim().toLocaleLowerCase("tr-TR") ||
    String(row.telefon || "").replace(/\D/g, "") ||
    getNetworkRowKey(row);
  const previous = networkRowMap.get(identity) || {};

  // Başvuru kaydı, taşıma için gerekli ilişki kimliğini içerdiği için önceliklidir.
  networkRowMap.set(identity, {
    ...previous,
    ...row,
    node_code: nodeCode || getNetworkNodeCode(previous),
    move_application_id:
      row.move_application_id || previous.move_application_id || null,
    source:
      row.source === "bayi_basvuru"
        ? "bayi_basvuru"
        : previous.source || row.source || "network",
  });
});

const uniqueNetworkRows = Array.from(networkRowMap.values());

const networkOwners = Array.from(
  new Set(
    uniqueNetworkRows
      .map(row => row.davet_eden_adi || row.ref_code)
      .filter(Boolean)
  )
);

const filteredNetworkRows = uniqueNetworkRows.filter(row => {
  const searchText = [
    row.ad_soyad,
    row.kurum_adi,
    row.email,
    row.telefon,
    row.ref_code,
    row.davet_eden_adi,
    row.talep_code,
    row.network_status,
  ]
    .join(" ")
    .toLocaleLowerCase("tr-TR");

  const searchOk = !networkSearch.trim()
    || searchText.includes(networkSearch.trim().toLocaleLowerCase("tr-TR"));

  const ownerOk = !networkOwnerFilter
    || row.davet_eden_adi === networkOwnerFilter
    || row.ref_code === networkOwnerFilter;

  return searchOk && ownerOk;
});

const networkForest = buildNetworkForest(filteredNetworkRows);

  /* ================= PANEL ================= */
  return (
    <div style={styles.page}>
     <div style={styles.hero}>
  <div>
    <div style={styles.kicker}>MesYat Digital Admin Panel</div>
    <h1 style={styles.heroTitle}>Bayi Yönetimi</h1>
    <p style={styles.heroText}>
      Bayi kayıtlarını, paket başvurularını, ödeme taleplerini ve network kullanıcılarını tek ekrandan yönetin.
    </p>
  </div>

  <div style={styles.heroActions}>
    <div style={styles.heroBadge}>
      <span style={styles.heroDot}></span>
      Aktif Oturum
    </div>

    <button style={styles.logoutBtn} onClick={logout}>
      Çıkış
    </button>
  </div>
</div>

      {message && (
        <div style={{
          ...styles.message,
          background: message.type === "error" ? "#fee2e2" : "#dcfce7",
          color: message.type === "error" ? "#991b1b" : "#166534"
        }}>
          {message.text}
        </div>
      )}

      {approvalDialog && (
        <div
          className="bayi-admin-modal-backdrop"
          role="dialog"
          aria-modal="true"
          aria-label="Bayi başvuru manuel onayı"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) closeApprovalDialog();
          }}
        >
          <div className="bayi-admin-modal">
            <div style={{
              padding: "20px 22px",
              background: "linear-gradient(135deg,#0f3a67,#1d4ed8)",
              color: "#fff",
              display: "flex",
              justifyContent: "space-between",
              gap: 16,
              alignItems: "flex-start",
            }}>
              <div>
                <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: ".08em", fontWeight: 900, color: "#bfdbfe" }}>
                  Manuel yönetici işlemi
                </div>
                <h3 style={{ margin: "5px 0 0", fontSize: 21 }}>
                  {approvalDialog.label} Onayı
                </h3>
                <div style={{ marginTop: 5, color: "#dbeafe", fontSize: 13 }}>
                  {approvalDialog.b?.firma_adi || approvalDialog.b?.ad_soyad || "Başvuru"}
                </div>
              </div>
              <button type="button" onClick={closeApprovalDialog} style={{ width: 36, height: 36, borderRadius: 11, border: "1px solid rgba(255,255,255,.25)", background: "rgba(255,255,255,.12)", color: "#fff", fontSize: 20, cursor: "pointer" }}>
                ×
              </button>
            </div>

            <div style={{ padding: 22 }}>
              <div style={{ display: "grid", gap: 9 }}>
                {[
                  ["Başvuru", `#${approvalDialog.b?.id || "-"}`],
                  ["Atanan kurum kodu", approvalDialog.b?.talep_code || "-"],
                  ["Bağlanacak kurum", approvalDialog.b?.yeni_kurum_code || approvalDialog.b?.talep_code || "-"],
                  ["Yeni durum", approvalDialog.label],
                ].map(([label, value]) => (
                  <div key={label} style={{ display: "flex", justifyContent: "space-between", gap: 14, padding: "10px 12px", borderRadius: 12, background: "#f8fafc", border: "1px solid #e2e8f0", fontSize: 13 }}>
                    <span style={{ color: "#64748b", fontWeight: 800 }}>{label}</span>
                    <b style={{ color: "#0f172a", textAlign: "right", overflowWrap: "anywhere" }}>{value}</b>
                  </div>
                ))}
              </div>

              {approvalDialog.durum === "aktif_bayi" && (
                <div style={{ marginTop: 12, padding: 13, borderRadius: 13, background: "#fff7ed", border: "1px solid #fed7aa", color: "#9a3412", fontSize: 12, fontWeight: 750, lineHeight: 1.55 }}>
                  Bu işlem yalnızca gerçek kurum kaydı oluşturulduktan sonra tamamlanır. Backend kurum kodunu bulamazsa onay vermez ve gerçek hata ayrıntısını gösterir.
                </div>
              )}

              <label style={{ display: "grid", gap: 6, marginTop: 14, color: "#334155", fontSize: 12, fontWeight: 900 }}>
                Yönetici Notu (isteğe bağlı)
                <textarea
                  value={approvalNote}
                  onChange={(event) => setApprovalNote(event.target.value)}
                  placeholder="İnceleme, telefon görüşmesi veya red gerekçesi..."
                  style={{ minHeight: 78, resize: "vertical", padding: 12, borderRadius: 12, border: "1px solid #cbd5e1", fontFamily: "inherit", color: "#0f172a" }}
                />
              </label>

              <label style={{ display: "flex", gap: 10, alignItems: "flex-start", marginTop: 14, padding: 13, borderRadius: 13, background: approvalConfirmed ? "#ecfdf5" : "#f8fafc", border: `1px solid ${approvalConfirmed ? "#86efac" : "#cbd5e1"}`, color: "#0f172a", fontSize: 13, fontWeight: 800, lineHeight: 1.5, cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={approvalConfirmed}
                  onChange={(event) => setApprovalConfirmed(event.target.checked)}
                  style={{ width: 18, height: 18, marginTop: 1 }}
                />
                <span>Başvuruyu ve atanacak durumu kontrol ettim; bu işlemi yönetici olarak manuel biçimde onaylıyorum.</span>
              </label>

              <div className="bayi-admin-actions" style={{ marginTop: 16, justifyContent: "flex-end" }}>
                <button type="button" onClick={closeApprovalDialog} disabled={!!bayiBasvuruLoadingId} style={{ padding: "11px 15px", borderRadius: 12, border: "1px solid #cbd5e1", background: "#fff", color: "#334155", fontWeight: 900, cursor: "pointer" }}>
                  Vazgeç
                </button>
                <button type="button" onClick={confirmBayiBasvuruDurum} disabled={!approvalConfirmed || !!bayiBasvuruLoadingId} style={{ padding: "11px 16px", borderRadius: 12, border: "none", background: approvalConfirmed ? (approvalDialog.durum === "reddedildi" ? "#dc2626" : "#16a34a") : "#cbd5e1", color: "#fff", fontWeight: 900, cursor: approvalConfirmed ? "pointer" : "not-allowed" }}>
                  {bayiBasvuruLoadingId ? "İşlem Yapılıyor..." : "Manuel İşlemi Onayla"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
<div style={styles.statsGrid}>
  <div style={styles.statCard}>
    <span style={styles.statIcon}>🏢</span>
    <div>
      <div style={styles.statLabel}>Toplam Bayi</div>
      <div style={styles.statValue}>{kurumTotal}</div>
    </div>
  </div>

  <div style={styles.statCard}>
    <span style={styles.statIcon}>📦</span>
    <div>
      <div style={styles.statLabel}>Paket Başvurusu</div>
      <div style={styles.statValue}>{paketBasvurulari.length}</div>
    </div>
  </div>

  <div style={styles.statCard}>
    <span style={styles.statIcon}>🤝</span>
    <div>
      <div style={styles.statLabel}>Bayi Başvurusu</div>
      <div style={styles.statValue}>
{bayiBasvurulari.filter(
  b => b.durum === "kayit_bekliyor" || b.durum === "bayi_adayi"
).length}

      </div>
    </div>
  </div>


  <div style={styles.statCard}>
    <span style={styles.statIcon}>💸</span>
    <div>
      <div style={styles.statLabel}>Ödeme Talebi</div>
      <div style={styles.statValue}>{odemeTalepleri.length}</div>
    </div>
  </div>

  <div style={styles.statCard}>
    <span style={styles.statIcon}>🌐</span>
    <div>
      <div style={styles.statLabel}>Network Kullanıcı</div>
      <div style={styles.statValue}>{networkUsers.length}</div>
    </div>
  </div>
</div>

<HaritaBasvurulari
  API={API}
  token={token}
  setMessage={setMessage}
/>

<MespuanGorevOnaylari
  API={API}
  token={token}
  setMessage={setMessage}
/>

<MarketplaceIlanOnaylari
  API={API}
  token={token}
  setMessage={setMessage}
/>

<MespuanReklamBasvurulari
  API={API}
  token={token}
  setMessage={setMessage}
/>

{/* ================= BAYİ BAŞVURULARI ================= */}

<div style={{ marginTop: 26 }}>
  <div style={styles.card}>
    <div style={styles.cardHeader}>
      <div>
        <div style={styles.cardEyebrow}>Onay bekleyen kayıtlar</div>
        <h3 style={styles.cardTitle}>
          🤝 Bayi Başvuruları ({filteredBayiBasvurulari.length})
        </h3>
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
 <button
  type="button"
  style={{
    ...styles.primaryBtn,
    width: "auto",
    padding: "10px 14px",
    fontSize: 13,
  }}
  onClick={fetchBayiBasvurulari}
>
  Yenile
</button>
      </div>
    </div>

    <div style={{ display: "flex", gap: 10, margin: "10px 0 20px", flexWrap: "wrap" }}>
  {[
  ["acik_basvurular", "Onay Süreci"],
  ["Tümü", "Tümü"],
  ["kayit_bekliyor", "Yeni Başvuru"],
  ["bayi_adayi", "Bayi Adayı"],
  ["aktif_bayi", "Aktif Bayi"],
  ["reddedildi", "Reddedildi"],
].map(([value, label]) => (

        <button
          key={value}
          type="button"
          onClick={() => setBayiBasvuruFilter(value)}
          style={{
            padding: "8px 14px",
            borderRadius: 999,
            border: "none",
            cursor: "pointer",
            fontWeight: 800,
            background:
              bayiBasvuruFilter === value
                ? "#2563eb"
                : "#e5e7eb",
            color:
              bayiBasvuruFilter === value
                ? "#fff"
                : "#111827",
          }}
        >
          {label}
        </button>
      ))}
    </div>

    <div className="bayi-admin-application-list">
      {filteredBayiBasvurulari.map((b) => {
        const isOpen = !!bayiBasvuruOpenById[b.id];
        const cityId = String(b.il || b.il_id || "").trim();
        const districtId = String(b.ilce || b.ilce_id || "").trim();
        const cityFromList = cities.find(
          (item) => String(item.id) === cityId
        );
        const cityName =
          b.il_adi ||
          b.city_name ||
          b.sehir_adi ||
          cityFromList?.name ||
          b.il ||
          "-";
        const districtName =
          b.ilce_adi ||
          b.district_name ||
          b.ilce_name ||
          applicationDistrictNames[`${cityId}:${districtId}`] ||
          b.ilce ||
          "-";

        return (
          <div
            key={b.id}
            className="bayi-admin-app-card"
            style={{
              border: "1px solid #dbe4f0",
              borderRadius: 18,
              background: "#fff",
              overflow: "hidden",
              boxShadow: "0 10px 28px rgba(15,23,42,.06)",
            }}
          >
            <button
              type="button"
              className="bayi-admin-app-summary"
              onClick={() =>
                setBayiBasvuruOpenById((prev) => ({
                  ...prev,
                  [b.id]: !prev[b.id],
                }))
              }
              style={{
                width: "100%",
                padding: 14,
                border: "none",
                background: isOpen ? "#f8fbff" : "#fff",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              <div style={{ minWidth: 0, display: "flex", gap: 12, alignItems: "center" }}>
                <span style={{
                  width: 44,
                  height: 44,
                  minWidth: 44,
                  borderRadius: 14,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "linear-gradient(135deg,#0f3a67,#2563eb)",
                  color: "#fff",
                  fontWeight: 900,
                  fontSize: 17,
                }}>
                  {String(b.firma_adi || b.ad_soyad || "B").charAt(0).toUpperCase()}
                </span>
                <span style={{ minWidth: 0 }}>
                  <b style={{ display: "block", color: "#0f172a", fontSize: 15, overflow: "hidden", textOverflow: "ellipsis" }}>
                    {b.firma_adi || "Firma adı yok"}
                  </b>
                  <span style={{ display: "block", color: "#64748b", fontSize: 12, marginTop: 3 }}>
                    {b.ad_soyad || "Başvuran belirtilmedi"} · Başvuru #{b.id}
                  </span>
                </span>
              </div>

              <div style={{ color: "#475569", fontSize: 12, lineHeight: 1.55 }}>
                <div>Referans: <b>{b.ref_code || "-"}</b></div>
                <div>Atanan kod: <b>{b.talep_code || "-"}</b></div>
              </div>

              <div style={{ display: "flex", gap: 9, alignItems: "center", justifyContent: "flex-end" }}>
                <span style={getBayiBasvuruDurumStyle(b.durum)}>
                  {getBayiBasvuruDurumText(b.durum)}
                </span>
                <span style={{ color: "#64748b", fontWeight: 900, fontSize: 18 }}>
                  {isOpen ? "−" : "+"}
                </span>
              </div>
            </button>

            {isOpen && (
              <div style={{ padding: "14px", borderTop: "1px solid #e8eef6" }}>
                <div className="bayi-admin-app-detail-grid">
                  {[
                    ["İletişim", b.email || "-", b.telefon || "-"],
                    ["Konum", cityName, `İlçe: ${districtName}`],
                    ["Referans Sahibi", b.davet_eden_adi || "-", `Kod: ${b.ref_code || "-"}`],
                    ["Başvuru Tarihi", b.created_at ? new Date(b.created_at).toLocaleString("tr-TR") : "-", `Kurum kodu: ${b.talep_code || "-"}`],
                  ].map(([label, value, sub]) => (
                    <div key={label} style={{ padding: 12, borderRadius: 14, background: "#f8fafc", border: "1px solid #e2e8f0", minWidth: 0 }}>
                      <span style={{ display: "block", fontSize: 10, color: "#64748b", fontWeight: 900, textTransform: "uppercase", letterSpacing: ".06em" }}>
                        {label}
                      </span>
                      <b style={{ display: "block", color: "#0f172a", marginTop: 5, overflowWrap: "anywhere" }}>{value}</b>
                      <span style={{ display: "block", color: "#64748b", fontSize: 11, marginTop: 4, overflowWrap: "anywhere" }}>{sub}</span>
                    </div>
                  ))}
                </div>

                {b.notu && (
                  <div style={{ marginTop: 10, padding: 12, borderRadius: 13, background: "#fff7ed", border: "1px solid #fed7aa", color: "#9a3412", fontSize: 13, lineHeight: 1.55 }}>
                    <b>Başvuru notu:</b> {b.notu}
                  </div>
                )}

                <div style={{
                  marginTop: 12,
                  padding: 13,
                  borderRadius: 14,
                  border: "1px solid #bfdbfe",
                  background: "#f8fbff",
                }}>
                  <div style={{ color: "#0f3a67", fontSize: 12, fontWeight: 900, marginBottom: 8 }}>
                    Üst Sponsor / Referans Düzeltme
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: 9 }}>
                    <input
                      style={{ ...styles.input, margin: 0 }}
                      inputMode="numeric"
                      maxLength={4}
                      aria-label="Yeni üst sponsor kodu"
                      value={bayiBasvuruRefDraft[b.id] ?? b.ref_code ?? ""}
                      onChange={(event) =>
                        setBayiBasvuruRefDraft((prev) => ({
                          ...prev,
                          [b.id]: event.target.value.replace(/\D/g, "").slice(0, 4),
                        }))
                      }
                      placeholder="Örn: 7118"
                    />
                    <button
                      type="button"
                      disabled={!!bayiBasvuruLoadingId}
                      onClick={() => correctBayiBasvuruReference(b)}
                      style={{
                        border: "none",
                        borderRadius: 11,
                        padding: "10px 14px",
                        background: "#0f3a67",
                        color: "#fff",
                        fontWeight: 900,
                        cursor: bayiBasvuruLoadingId ? "wait" : "pointer",
                      }}
                    >
                      Referansı Düzelt
                    </button>
                  </div>
                  <div style={{ color: "#64748b", fontSize: 11, marginTop: 7, lineHeight: 1.45 }}>
                    Yanlış linkten geldiyse doğru kurum kodunu yaz. Kişi ve bütün alt ekibi yeni sponsora bağlanır; üçüncü seviyeye ödeme oluşturulmaz.
                  </div>
                </div>

                <div className="bayi-admin-actions" style={{ marginTop: 12 }}>
                  <button type="button" style={{ padding: "10px 13px", border: "none", borderRadius: 11, background: "#f97316", color: "#fff", fontWeight: 900, cursor: "pointer" }} onClick={() => aktarBayiBasvuruToCreateForm(b)}>
                    1. Forma Aktar
                  </button>

                  {b.durum === "kayit_bekliyor" && (
                    <button type="button" disabled={!!bayiBasvuruLoadingId} style={{ padding: "10px 13px", border: "none", borderRadius: 11, background: "#2563eb", color: "#fff", fontWeight: 900, cursor: "pointer" }} onClick={() => updateBayiBasvuruDurum(b, "bayi_adayi")}>
                      2. Aday Olarak İncele
                    </button>
                  )}

                  {b.durum !== "aktif_bayi" && (
                    <button type="button" disabled={!!bayiBasvuruLoadingId} style={{ padding: "10px 13px", border: "none", borderRadius: 11, background: "#16a34a", color: "#fff", fontWeight: 900, cursor: "pointer" }} onClick={() => updateBayiBasvuruDurum(b, "aktif_bayi")}>
                      3. Manuel Onay Ver
                    </button>
                  )}

                  {b.durum !== "reddedildi" && (
                    <button type="button" disabled={!!bayiBasvuruLoadingId} style={{ padding: "10px 13px", border: "1px solid #fecaca", borderRadius: 11, background: "#fff1f2", color: "#b91c1c", fontWeight: 900, cursor: "pointer" }} onClick={() => updateBayiBasvuruDurum(b, "reddedildi")}>
                      Başvuruyu Reddet
                    </button>
                  )}
                </div>

                <div style={{ marginTop: 12, padding: "10px 12px", borderRadius: 12, background: "#eff6ff", color: "#1e40af", border: "1px solid #bfdbfe", fontSize: 12, fontWeight: 750, lineHeight: 1.5 }}>
                  Güvenlik: Başvuru kendiliğinden aktif olmaz. Kurum kaydı oluşturulduktan sonra “Manuel Onay Ver” işlemi ayrıca doğrulanmalıdır.
                </div>
              </div>
            )}
          </div>
        );
      })}

      {!filteredBayiBasvurulari.length && (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>🤝</div>
          <b>Bu filtrede başvuru yok</b>
          <span>Yeni kayıt geldiğinde burada onay bekleyen başvuru olarak görünecek.</span>
        </div>
      )}
    </div>

    <div
      style={{
        marginTop: 14,
        padding: 14,
        borderRadius: 14,
        background: "#f8fafc",
        border: "1px solid #e5e7eb",
        color: "#475569",
        fontSize: 13,
        fontWeight: 700,
        lineHeight: 1.6,
      }}
    >
      “Forma Aktar” butonu başvurudaki firma adı, e-posta, kategori, il, ilçe
      ve sistemin verdiği kurum kodunu yukarıdaki “Yeni Bayi Ekle” formuna taşır.
      Şifreyi sen yazıp “Bayiyi Kaydet” dediğinde bayi gerçek kurum olarak oluşur.
    </div>
  </div>
</div>

<div style={styles.layout} className="admin-layout">
  <div style={styles.card} className="admin-card">
    <div style={styles.cardHeader}>
      <div>
        <div style={styles.cardEyebrow}>Yeni kayıt</div>
        <h3 style={styles.cardTitle}>Yeni Bayi Ekle</h3>
      </div>
      <div style={styles.cardIcon}>＋</div>
    </div>

    <div style={styles.formGrid}>


      <input style={styles.input} placeholder="Kurum Adı" value={ad} onChange={e => setAd(e.target.value)} />
    
<input
  style={styles.input}
  placeholder="Kurum Kodu"
  value={code}
  onChange={e => {
    const v = e.target.value.replace(/\D/g, "").slice(0, 4);
    setCode(v);
    setShortCode(v);
  }}
/>

<input
  style={{
    ...styles.input,
    background: "#f8fafc",
    color: "#475569",
    fontWeight: 800,
  }}
  placeholder="Short Code"
  value={shortCode}
  readOnly
/>

      <input style={styles.input} placeholder="Admin E-posta" value={adminEmail} onChange={e => setAdminEmail(e.target.value)} />
      <input style={styles.input} placeholder="Admin Şifre" value={adminPassword} onChange={e => setAdminPassword(e.target.value)} />

      <select
        style={styles.input}
        value={kategoriId}
        onChange={e => setKategoriId(e.target.value)}
      >
        <option value="">Kategori Seç</option>
        <option value="1">Sağlık</option>
        <option value="2">Eğitim</option>
        <option value="3">Restoran</option>
        <option value="4">Spor</option>
        <option value="5">STK</option>
        <option value="6">Finans</option>
        <option value="7">Teknoloji</option>
        <option value="8">Turizm</option>
        <option value="9">Danışmanlık</option>
        <option value="10">Emlak</option>
        <option value="11">Hizmet</option>
        <option value="12">Üretim</option>
        <option value="13">Otomotiv</option>
        <option value="14">Medya</option>
        <option value="15">Enerji</option>
        <option value="16">Kişisel Gelişim</option>
        <option value="17">Diğer</option>
      </select>

      <select
        style={styles.input}
        value={city}
        onChange={e => setCity(e.target.value)}
      >
        <option value="">İl Seçiniz</option>
        {cities.map(c => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </select>

      <select
        style={{
          ...styles.input,
          opacity: districts.length ? 1 : 0.65,
          cursor: districts.length ? "pointer" : "not-allowed"
        }}
        value={district}
        disabled={!districts.length}
        onChange={e => setDistrict(e.target.value)}
      >
        <option value="">İlçe Seçiniz</option>
        {districts.map(d => (
          <option key={d.id} value={d.id}>{d.name}</option>
        ))}
      </select>
    </div>

    <button style={styles.primaryBtn} onClick={createKurum}>
      {loading ? "Kaydediliyor..." : "Bayiyi Kaydet"}
    </button>
  </div>

  <div style={styles.card}>
    <button
      type="button"
      onClick={() => setKurumListOpen((value) => !value)}
      style={{
        ...styles.cardHeader,
        width: "100%",
        border: "none",
        background: "transparent",
        cursor: "pointer",
        textAlign: "left",
      }}
    >
      <div>
        <div style={styles.cardEyebrow}>Kayıtlı işletmeler</div>
        <h3 style={styles.cardTitle}>
          Bayiler ({search.trim() ? `${kurumListTotal} arama sonucu` : kurumListTotal})
        </h3>
        <div style={{ marginTop: 5, color: "#64748b", fontSize: 12, fontWeight: 700 }}>
          Sayfa {kurumPage} / {kurumTotalPages} · Her sayfada {KURUM_PAGE_SIZE} kayıt
        </div>
      </div>
      <div style={styles.cardIcon}>{kurumListOpen ? "−" : "+"}</div>
    </button>

    {kurumListOpen && (
      <>
    <input
      style={styles.searchInput}
      placeholder="Bayi adı veya kurum kodu ara..."
      value={search}
      onChange={e => {
        setSearch(e.target.value);
        setKurumPage(1);
      }}
    />

    <div style={styles.bayiList}>
     


{filtered.map(k => {
  const subeState = subelerByKurum[k.old_id];
  const subeler = subeState?.data || [];
  const kurumSubeInfo = subeState?.kurum || k;
  const multiBranchEnabled = !!kurumSubeInfo.multi_branch_enabled;
  const subeForm = getSubeForm(k.old_id);
  const subeLinkForm = getSubeLinkForm(k.old_id);
  const subeMode = getSubeMode(k.old_id);

const kurumEditOpen = !!kurumEditOpenById[k.old_id];
const kurumEditForm = getKurumEditForm(k.old_id);

const referansForm = getReferansForm(k.old_id);
const referansIslemler = referansIslemlerByKurum[k.old_id] || [];
const referansEditId = referansEditByKurum[k.old_id];

  return (
    <details
      key={k.old_id}
      style={styles.accordion}
      
onToggle={(e) => {
  if (e.currentTarget.open) {
    if (!subelerByKurum[k.old_id]) {
      fetchSubeler(k.old_id);
    }

    if (!referansIslemlerByKurum[k.old_id]) {
      fetchReferansIslemler(k.old_id);
    }
  }
}}

    >
      <summary style={styles.summary}>
        <div style={styles.bayiSummaryLeft}>
          <div style={styles.avatar}>
            {String(k.ad || "?").charAt(0).toUpperCase()}
          </div>

          <div>
            <div style={styles.bayiName}>{k.ad}</div>
            <div style={styles.bayiMeta}>
              Kod: <b>{k.code}</b> · Short: <b>{k.short_code}</b>
            </div>
          </div>
        </div>

        <span style={styles.statusBadge}>Aktif</span>
      </summary>

      <div style={styles.detail}>
        <div style={styles.detailGrid}>
          <div style={styles.infoBox}>
            <span style={styles.infoLabel}>Kurum ID</span>
            <b>{k.old_id}</b>
          </div>

          <div style={styles.infoBox}>
            <span style={styles.infoLabel}>Kurum Kodu</span>
            <b>{k.code}</b>
          </div>

          <div style={styles.infoBox}>
            <span style={styles.infoLabel}>Short Code</span>
            <b>{k.short_code}</b>
          </div>
        </div>

        {/* ================= GENEL BAYİ DÜZENLEME ================= */}
        <div style={styles.kurumEditBox}>
          <div style={styles.kurumEditTop}>
            <div>
              <div style={styles.kurumEditTitle}>⚙️ Genel Bayi Bilgileri</div>
              <div style={styles.kurumEditDesc}>
                İşletme, panel kullanıcısı ve üst sponsor bağlantısını buradan güvenli biçimde güncelleyebilirsin.
              </div>
            </div>

            <button
              type="button"
              style={styles.kurumEditToggleBtn}
              onClick={() => openKurumEdit(k)}
            >
              {kurumEditOpen ? "Düzenlemeyi Kapat" : "Genel Bilgileri Düzenle"}
            </button>
          </div>

          {kurumEditOpen && (
            <div style={styles.kurumEditForm}>
              <input
                style={styles.input}
                placeholder="İşletme / Kurum Adı"
                value={kurumEditForm.ad}
                onChange={e => setKurumEditField(k.old_id, "ad", e.target.value)}
              />

              <input
                style={styles.input}
                placeholder="Kurum Kodu Örn: 7054"
                value={kurumEditForm.code}
                onChange={e => setKurumEditField(k.old_id, "code", e.target.value)}
              />

              <input
                style={styles.input}
                placeholder="Short Code Örn: 7054"
                value={kurumEditForm.short_code}
                onChange={e => setKurumEditField(k.old_id, "short_code", e.target.value)}
              />

              <input
                style={styles.input}
                placeholder="Panel Kullanıcı Adı"
                value={kurumEditForm.kullanici_adi}
                onChange={e => setKurumEditField(k.old_id, "kullanici_adi", e.target.value)}
              />

              <input
                style={styles.input}
                placeholder="Panel Admin E-posta"
                value={kurumEditForm.email}
                onChange={e => setKurumEditField(k.old_id, "email", e.target.value)}
              />

              <label style={styles.dateFieldBox}>
                <span style={styles.dateLabel}>Üst Sponsor / Referans Kodu</span>
                <input
                  style={styles.input}
                  inputMode="numeric"
                  maxLength={4}
                  placeholder="Örn: 7118"
                  value={kurumEditForm.referans_code}
                  onChange={e =>
                    setKurumEditField(
                      k.old_id,
                      "referans_code",
                      e.target.value.replace(/\D/g, "").slice(0, 4)
                    )
                  }
                />
                <small style={{ color: "#64748b", lineHeight: 1.45 }}>
                  Mevcut sponsor: <b>{kurumEditForm.referans_adi || kurumEditForm.referans_code || "Bağlantı yok"}</b>.
                  Yanlış linkten kayıt olduysa doğru kurum kodunu buraya yazabilirsin.
                </small>
              </label>

             <input
  style={styles.input}
  type="password"
  placeholder="Yeni şifre gir - boş bırakırsan mevcut şifre korunur"
  value={kurumEditForm.sifre}
  onChange={e => setKurumEditField(k.old_id, "sifre", e.target.value)}
/>

            <div style={styles.kurumEditPasswordNote}>
  Mevcut şifre güvenlik nedeniyle gösterilmez. Yeni şifre yazarsan değişir, boş bırakırsan korunur.
</div>

              <div style={styles.kurumEditActions}>
                <button
                  type="button"
                  style={{
                    ...styles.kurumEditSaveBtn,
                    opacity: kurumEditLoadingId === k.old_id ? 0.65 : 1,
                    cursor: kurumEditLoadingId === k.old_id ? "not-allowed" : "pointer",
                  }}
                  disabled={kurumEditLoadingId === k.old_id}
                  onClick={() => saveKurumEdit(k.old_id)}
                >
                  {kurumEditLoadingId === k.old_id
                    ? "Güncelleniyor..."
                    : "Bayi Bilgilerini Güncelle"}
                </button>

                <button
                  type="button"
                  style={styles.kurumEditCancelBtn}
                  onClick={() => cancelKurumEdit(k.old_id)}
                >
                  Vazgeç
                </button>
              </div>
            </div>
          )}
        </div>

        {/* ================= ŞUBE YÖNETİMİ ================= */}
        <div style={styles.subeBox}>
          <div style={styles.subeTop}>
            <div>
              <div style={styles.subeTitle}>Şube Yönetimi</div>
              <div style={styles.subeDesc}>
                Bu bayiye bağlı Merkez ve diğer şubeleri buradan yönetebilirsin.
              </div>
            </div>

            <button
              type="button"
              style={{
                ...styles.subeToggleBtn,
                background: multiBranchEnabled ? "#16a34a" : "#64748b",
              }}
              onClick={() => toggleMultiBranch(k.old_id, !multiBranchEnabled)}
            >
              {multiBranchEnabled ? "Çok Şubeli Açık" : "Çok Şubeli Kapalı"}
            </button>
          </div>

          <button
            type="button"
            style={styles.subeRefreshBtn}
            onClick={() => fetchSubeler(k.old_id)}
          >
            {subeLoadingId === k.old_id
              ? "Şubeler yükleniyor..."
              : "Şubeleri Göster / Yenile"}
          </button>

          <div style={styles.subeList}>
            {subeler.map(s => (
              <div key={s.id} style={styles.subeItem}>
                <div>
                  <div style={styles.subeName}>
                    {s.sube_adi}

{s.is_default && (
  <span style={styles.defaultBadge}>Merkez</span>
)}

{s.source_type === "linked" && (
  <span style={styles.linkedBadge}>Bağlı Kurum</span>
)}

{!s.aktif && (
  <span style={styles.passiveBadge}>Pasif</span>
)}
                  </div>

                 <div style={styles.subeMeta}>
  Kod: <b>{s.sube_code || "-"}</b> · Yetki:{" "}
  <b>{s.access_scope === "all" ? "Tüm şubeler" : "Sadece bu şube"}</b>
</div>

<div style={styles.subeMeta}>
  Panel: <b>{s.panel_email || "Panel e-postası yok"}</b>
</div>

<div style={styles.subeMeta}>
  {s.telefon || "Telefon yok"} · {s.adres || "Adres yok"}
</div>

                </div>

           {s.source_type === "linked" && s.linked_old_id && (
 <button
  type="button"
  style={{
    ...styles.subeDangerLightBtn,
    opacity:
      subeLoadingId === `unlink-${k.old_id}-${s.linked_old_id}` ? 0.65 : 1,
    cursor:
      subeLoadingId === `unlink-${k.old_id}-${s.linked_old_id}`
        ? "not-allowed"
        : "pointer",
  }}
  disabled={subeLoadingId === `unlink-${k.old_id}-${s.linked_old_id}`}
  onClick={() => unlinkExistingKurumAsSube(k.old_id, s.linked_old_id)}
>
  {subeLoadingId === `unlink-${k.old_id}-${s.linked_old_id}`
    ? "Ayrılıyor..."
    : "Bağlantıyı Ayır"}
</button>
)}

{s.source_type !== "linked" && !s.is_default && s.aktif && (
  <button
    type="button"
    style={styles.subePassiveBtn}
    onClick={() => passiveSube(k.old_id, s.id)}
  >
    Pasifleştir
  </button>
)}
              </div>
            ))}

            {!subeler.length && (
              <div style={styles.subeEmpty}>
                Şube bilgisi henüz yüklenmedi. “Şubeleri Göster / Yenile” butonuna bas.
              </div>
            )}
          </div>


<div style={styles.subeTabs}>
  <button
    type="button"
    style={{
      ...styles.subeTabBtn,
      background: subeMode === "create" ? "#2563eb" : "#e2e8f0",
      color: subeMode === "create" ? "#fff" : "#0f172a",
    }}
    onClick={() => setSubeMode(k.old_id, "create")}
  >
    Yeni Şube Aç
  </button>

  <button
    type="button"
    style={{
      ...styles.subeTabBtn,
      background: subeMode === "link" ? "#f97316" : "#e2e8f0",
      color: subeMode === "link" ? "#fff" : "#0f172a",
    }}
    onClick={() => setSubeMode(k.old_id, "link")}
  >
    Mevcut Kurumu Bağla
  </button>
</div>

{subeMode === "create" && (
  <>
    <div style={styles.subeHelper}>
      Yeni şube açarken daha önce kullanılmamış yeni bir kod gir. Örnek: 7061.  
      Zaten açılmış bir kurum kodunu burada kullanma.
    </div>

    <div style={styles.subeForm}>
      <input
        style={styles.input}
        placeholder="Yeni Şube Adı"
        value={subeForm.sube_adi}
        onChange={e => setSubeField(k.old_id, "sube_adi", e.target.value)}
      />

      <input
        style={styles.input}
        placeholder="Yeni Şube Kodu Örn: 7061"
        value={subeForm.sube_code}
        onChange={e => setSubeField(k.old_id, "sube_code", e.target.value)}
      />

    <input
  style={styles.input}
  type="password"
  placeholder="Panel Şifre"
  value={subeForm.panel_password}
  onChange={e => setSubeField(k.old_id, "panel_password", e.target.value)}
/>

      <select
        style={styles.input}
        value={subeForm.access_scope}
        onChange={e => setSubeField(k.old_id, "access_scope", e.target.value)}
      >
        <option value="branch">Sadece bu şube</option>
        <option value="all">Tüm şubeler</option>
      </select>

      <input
        style={styles.input}
        placeholder="Telefon"
        value={subeForm.telefon}
        onChange={e => setSubeField(k.old_id, "telefon", e.target.value)}
      />

      <input
        style={styles.input}
        placeholder="Adres"
        value={subeForm.adres}
        onChange={e => setSubeField(k.old_id, "adres", e.target.value)}
      />

    <button
  type="button"
  style={{
    ...styles.subeAddBtn,
    opacity: subeLoadingId === `create-${k.old_id}` ? 0.65 : 1,
    cursor: subeLoadingId === `create-${k.old_id}` ? "not-allowed" : "pointer",
  }}
  disabled={subeLoadingId === `create-${k.old_id}`}
  onClick={() => createSube(k.old_id)}
>
  {subeLoadingId === `create-${k.old_id}`
    ? "Şube oluşturuluyor..."
    : "Yeni Şubeyi Oluştur"}
</button>
    </div>
  </>
)}

{subeMode === "link" && (
  <>
    <div style={styles.subeHelper}>
      Zaten ayrı admin olarak açılmış kurumu merkeze bağlamak için kurum kodu veya kurum ID gir.  
      Örnek: Ateş Cafe merkez 7047 ise, bağlanacak kurum 7060 olabilir.
    </div>

    <div style={styles.subeForm}>
      <input
        style={styles.input}
        placeholder="Mevcut Kurum Kodu veya ID Örn: 7060 / 401"
        value={subeLinkForm.kurum_code}
        onChange={e => setSubeLinkField(k.old_id, "kurum_code", e.target.value)}
      />

      <input
        style={styles.input}
        placeholder="Panel E-posta Opsiyonel"
        value={subeLinkForm.panel_email}
        onChange={e => setSubeLinkField(k.old_id, "panel_email", e.target.value)}
      />

    <button
  type="button"
  style={{
    ...styles.subeLinkBtn,
    opacity: subeLoadingId === `link-${k.old_id}` ? 0.65 : 1,
    cursor: subeLoadingId === `link-${k.old_id}` ? "not-allowed" : "pointer",
  }}
  disabled={subeLoadingId === `link-${k.old_id}`}
  onClick={() => linkExistingKurumAsSube(k.old_id)}
>
  {subeLoadingId === `link-${k.old_id}`
    ? "Bağlanıyor..."
    : "Mevcut Kurumu Bu Merkeze Bağla"}
</button>
    </div>
  </>
)}

        </div>


        {/* ================= REFERANS / SATIŞ İŞLEMLERİ ================= */}
        <div style={styles.referansBox}>
          <div style={styles.referansTop}>
            <div>
              <div style={styles.referansTitle}>🤝 Referans / Satış İşlemleri</div>
              <div style={styles.referansDesc}>
                Bu bölüm sadece bilgi amaçlıdır. Ödeme, tahsilat, hak ediş veya fatura takibi değildir.
              </div>
            </div>

            <div style={styles.referansInfoBadge}>
              Bilgi Kaydı
            </div>
          </div>

          <div style={styles.referansForm}>
            <input
              style={styles.input}
              placeholder="Referans / Satışçı Örn: Olcay"
              value={referansForm.referans}
              onChange={e => setReferansField(k.old_id, "referans", e.target.value)}
            />

            <input
              style={styles.input}
              placeholder="Firma / İşletme Adı Örn: Bursa X Cafe"
              value={referansForm.firma_adi}
              onChange={e => setReferansField(k.old_id, "firma_adi", e.target.value)}
            />

            <input
              style={styles.input}
              placeholder="Satılan Ürün / Paket Örn: QR Menü + Stok"
              value={referansForm.satilan_urun}
              onChange={e => setReferansField(k.old_id, "satilan_urun", e.target.value)}
            />

        <select
  style={styles.input}
  value={referansForm.islem_tipi}
  onChange={e => setReferansField(k.old_id, "islem_tipi", e.target.value)}
>
  {ISLEM_TIPLERI.map(opt => (
    <option key={opt.value} value={opt.value}>
      {opt.label}
    </option>
  ))}
</select>

<input
  style={styles.input}
  type="number"
  min="0"
  step="0.01"
  placeholder="Satış Tutarı Örn: 20000"
  value={referansForm.satis_tutari}
  onChange={e => setReferansField(k.old_id, "satis_tutari", e.target.value)}
/>



<div style={{
  gridColumn: "1 / -1",
  border: "1px solid #bfdbfe",
  borderRadius: 16,
  overflow: "hidden",
  background: "#fff",
}}>
  <div style={{ padding: "11px 13px", background: "#0f3a67", color: "#fff", fontWeight: 900 }}>
    Sabit İki Kademeli Kazanç Dağılımı
  </div>

  {[
    ["1", "Satışı yapan doğrudan bayi", DOGRUDAN_BAYI_ORANI, hesaplaHakedis(referansForm.satis_tutari, DOGRUDAN_BAYI_ORANI), "Kazanç yansır"],
    ["2", "Bir üst sponsor", UST_SPONSOR_ORANI, hesaplaHakedis(referansForm.satis_tutari, UST_SPONSOR_ORANI), "Kazanç yansır"],
    ["3+", "Daha üst sponsorlar", 0, 0, "Sadece ağaçta görünür"],
  ].map(([level, label, rate, amount, status]) => (
    <div key={level} className="bayi-admin-commission-row" style={{
      display: "grid",
      gridTemplateColumns: "60px minmax(0,1fr) 80px minmax(120px,.55fr) minmax(150px,.7fr)",
      gap: 10,
      alignItems: "center",
      padding: "11px 13px",
      borderTop: "1px solid #e2e8f0",
      color: "#334155",
      fontSize: 12,
    }}>
      <b>{level}. seviye</b>
      <span>{label}</span>
      <b>%{rate}</b>
      <b>{paraFormat(amount)}</b>
      <span style={{ color: rate ? "#15803d" : "#64748b", fontWeight: 800 }}>{status}</span>
    </div>
  ))}

  <div style={{ padding: "12px 13px", background: "#eff6ff", color: "#1e3a8a", fontSize: 12, fontWeight: 850, lineHeight: 1.55 }}>
    Toplam dağıtım: <b>%50</b> · Doğrudan bayi %40 + tek üst sponsor %10.
    Üçüncü ve daha üst seviyeler ekip ağacında görünür; kazanç ve bakiyeye yansımaz.
  </div>
</div>

<div style={styles.dateFieldBox}>
  <label style={styles.dateLabel}>
    {referansForm.islem_tipi === "demo"
      ? "Demo Tarihi"
      : "Sözleşme Başlangıç Tarihi"}
  </label>

  <input
    style={styles.input}
    type="date"
    value={referansForm.sozlesme_baslangic}
    onChange={e =>
      setReferansField(k.old_id, "sozlesme_baslangic", e.target.value)
    }
  />
</div>

<div style={styles.dateFieldBox}>
  <label style={styles.dateLabel}>
    Otomatik Bitiş Tarihi
  </label>

  <input
    style={{
      ...styles.input,
      background: "#f1f5f9",
      color: "#475569",
      cursor: "not-allowed",
    }}
    type="date"
    value={referansForm.sozlesme_bitis}
    readOnly
  />
</div>

            <textarea
              style={styles.referansTextArea}
              placeholder="Not: anlaşma detayı, hangi modüller verildi, özel açıklama..."
              value={referansForm.anlasma_notu}
              onChange={e => setReferansField(k.old_id, "anlasma_notu", e.target.value)}
            />

            <div style={styles.referansActions}>
              <button
                type="button"
                style={styles.referansSaveBtn}
                onClick={() => saveReferansIslem(k.old_id, k)}
              >
                {referansEditId ? "İşlemi Güncelle" : "İşlemi Kaydet"}
              </button>

              {referansEditId && (
                <button
                  type="button"
                  style={styles.referansCancelBtn}
                  onClick={() => resetReferansForm(k.old_id)}
                >
                  Vazgeç
                </button>
              )}
            </div>
          </div>

          <div style={styles.referansList}>
            {referansIslemler.map(row => (
              <div key={row.id} style={styles.referansItem}>
                <div style={styles.referansItemMain}>
                  <div style={styles.referansItemHeader}>
                    <b>{row.firma_adi}</b>
                    <span style={styles.referansSmallBadge}>
                      {row.referans}
                    </span>
                  </div>

              <div style={styles.referansMeta}>
  İşlem Tipi: <b>{ISLEM_TIPLERI.find(x => x.value === row.islem_tipi)?.label || "Satış"}</b>
</div>

<div style={styles.referansMeta}>
  Satılan: <b>{row.satilan_urun}</b>
</div>

<div style={styles.referansMeta}>
  Satış Tutarı: <b>{paraFormat(row.satis_tutari)}</b>
</div>

<div style={styles.referansMeta}>
  Doğrudan bayi: <b>%{DOGRUDAN_BAYI_ORANI} · {paraFormat(hesaplaHakedis(row.satis_tutari, DOGRUDAN_BAYI_ORANI))}</b>
  {" · "}Üst sponsor: <b>%{UST_SPONSOR_ORANI} · {paraFormat(hesaplaHakedis(row.satis_tutari, UST_SPONSOR_ORANI))}</b>
</div>

<div style={styles.referansMeta}>
  3. ve daha üst sponsorlar: <b>Sadece görünür, kazanç 0</b>
</div>

<div style={styles.referansMeta}>
  Tarih: <b>{formatSimpleDate(row.sozlesme_baslangic)}</b> -{" "}
  <b>{formatSimpleDate(row.sozlesme_bitis)}</b>
</div>

                  {row.anlasma_notu && (
                    <div style={styles.referansNote}>
                      {row.anlasma_notu}
                    </div>
                  )}
                </div>

                <div style={styles.referansItemActions}>
                  <button
                    type="button"
                    style={styles.referansEditBtn}
                    onClick={() => editReferansIslem(k.old_id, row)}
                  >
                    Düzenle
                  </button>

                  <button
                    type="button"
                    style={styles.referansDeleteBtn}
                    onClick={() => deleteReferansIslem(k.old_id, row.id)}
                  >
                    Sil
                  </button>
                </div>
              </div>
            ))}

            {!referansIslemler.length && (
              <div style={styles.referansEmpty}>
                Henüz işlem kaydı yok. Bu bayinin getirdiği firma ve satılan ürünü yukarıdan ekleyebilirsin.
              </div>
            )}
          </div>
        </div>

       <button
  style={styles.deleteBtn}
  onClick={() => deleteKurum(k)}
>
  Bayiyi Sil / Pasifleştir
</button>
      </div>
    </details>
  );
})}


      {!filtered.length && (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>🔍</div>
          <b>Kayıt bulunamadı</b>
          <span>Arama kriterini değiştirerek tekrar deneyebilirsin.</span>
        </div>
      )}
    </div>

    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 10,
      marginTop: 14,
      paddingTop: 14,
      borderTop: "1px solid #e2e8f0",
      flexWrap: "wrap",
    }}>
      <button
        type="button"
        disabled={kurumPage <= 1}
        onClick={() => setKurumPage((page) => Math.max(1, page - 1))}
        style={{
          ...styles.kurumEditCancelBtn,
          opacity: kurumPage <= 1 ? 0.45 : 1,
          cursor: kurumPage <= 1 ? "not-allowed" : "pointer",
        }}
      >
        ← Önceki Sayfa
      </button>

      <b style={{ color: "#334155", fontSize: 13 }}>
        {kurumListTotal} kayıt · {kurumPage}. sayfa
      </b>

      <button
        type="button"
        disabled={kurumPage >= kurumTotalPages}
        onClick={() => setKurumPage((page) => Math.min(kurumTotalPages, page + 1))}
        style={{
          ...styles.kurumEditSaveBtn,
          flex: "0 0 auto",
          opacity: kurumPage >= kurumTotalPages ? 0.45 : 1,
          cursor: kurumPage >= kurumTotalPages ? "not-allowed" : "pointer",
        }}
      >
        Sonraki Sayfa →
      </button>
    </div>
      </>
    )}
  </div>
</div>      
      {/* ================= KURUMSAL PAKET BAŞVURULARI ================= */}
      <div style={{ marginTop: 40 }}>
        <div style={styles.card}>
<h3>📦 Paket Başvuruları (Kurumsal)</h3>

<div style={{ display: "flex", gap: 10, margin: "10px 0 20px" }}>
  {["Tümü", "Beklemede", "Onaylandı"].map(f => (
    <button
      key={f}
      onClick={() => setPaketFilter(f)}
      style={{
        padding: "8px 14px",
        borderRadius: 8,
        border: "none",
        cursor: "pointer",
        fontWeight: 700,
        background:
          paketFilter === f
            ? "#2563eb"
            : "#e5e7eb",
        color:
          paketFilter === f
            ? "#fff"
            : "#111827"
      }}
    >
      {f}
    </button>
  ))}
</div>

          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#f1f5f9", textAlign: "left" }}>
                  <th style={styles.th}>Başvuran</th>
                  <th style={styles.th}>Referans</th>
 <th style={styles.th}>Paket</th>
<th style={styles.th}>Başlangıç</th>
<th style={styles.th}>Bitiş</th>
<th style={styles.th}>Kalan Süre</th>
<th style={styles.th}>Durum</th>

                  <th style={styles.th}>İşlem</th>
                </tr>
              </thead>
<tbody>
{filteredPaketler.map(b => {
 const baslangic = b.baslangic_tarihi
  ? new Date(b.baslangic_tarihi)
  : null;

const bitis = b.bitis_tarihi
  ? new Date(b.bitis_tarihi)
  : null;

const gun = bitis ? kalanGun(bitis) : null;



    return (
      <tr key={b.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
        <td style={styles.td}>{b.ad}</td>
        <td style={styles.td}>{b.referans}</td>
        <td style={styles.td}><b>{b.paket}</b></td>

      <td style={styles.td}>
  {baslangic ? baslangic.toLocaleDateString("tr-TR") : "-"}
</td>

<td style={styles.td}>
  {bitis ? bitis.toLocaleDateString("tr-TR") : "-"}
</td>


 <td style={styles.td}>
  {gun !== null && (
    <>
      {/* AKTİF PAKET */}
      {gun > 0 && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background:
            gun <= 3 ? "#fecaca" :
            gun <= 7 ? "#fde68a" :
            gun <= 30 ? "#bfdbfe" : "#dcfce7",
          color:
            gun <= 3 ? "#991b1b" :
            gun <= 7 ? "#92400e" :
            gun <= 30 ? "#1e40af" : "#166534"
        }}>
          {gun} gün kaldı
        </span>
      )}

      {/* UPGRADE EDİLMİŞ PAKET */}
      {gun <= 0 && b.upgraded === true && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background: "#dbeafe",
          color: "#1e40af"
        }}>
          🔵 Paket yükseltildi
        </span>
      )}

      {/* GERÇEKTEN SÜRESİ DOLMUŞ */}
      {gun <= 0 && !b.upgraded && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background: "#fecaca",
          color: "#991b1b"
        }}>
          🔴 Süresi doldu
        </span>
      )}
    </>
  )}
</td>


   <td style={styles.td}>{b.durum}</td>

<td style={styles.td}>
  {b.durum === "Beklemede" && (
    <button
      style={styles.approveBtn}
      onClick={() => onaylaPaket(b)}
    >
      Onayla
    </button>
  )}
</td>
      </tr>
    );
  })}
</tbody>
</table>
</div>
</div>



{/* ================= ÖDEME TALEPLERİ (AKORDİYON) ================= */}
<div style={{ marginTop: 40 }}>
  <div style={styles.card}>
    <div
      onClick={() => setOdemeOpen(!odemeOpen)}
      style={{
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer",
        fontWeight: 800,
        fontSize: 18
      }}
    >
      <span>💸 Ödeme Talepleri (Referans Kazanç)</span>
      <span>{odemeOpen ? "−" : "+"}</span>
    </div>

    {odemeOpen && (
      <div style={{ marginTop: 20, overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={styles.th}>Kullanıcı</th>
              <th style={styles.th}>Tutar</th>
              <th style={styles.th}>Talep Tarihi</th>
              <th style={styles.th}>Durum</th>
              <th style={styles.th}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {odemeTalepleri.map(o => (
              <tr key={o.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                <td style={styles.td}>{o.user_name}</td>
                <td style={styles.td}><b>{Number(o.amount).toFixed(2)} ₺</b></td>
                <td style={styles.td}>
                  {new Date(o.created_at).toLocaleDateString("tr-TR")}
                </td>
                <td style={styles.td}>{o.status}</td>
                <td style={styles.td}>
                  {o.status === "requested" && (
                    <button
                      style={styles.approveBtn}
                      onClick={async () => {
                        await fetch(`${API}/admin/payout-approve/${o.id}`, {
                          method: "POST",
                          headers: { Authorization: `Bearer ${token}` }
                        });
                        fetchOdemeTalepleri();
                      }}
                    >
                      Ödemeyi Onayla
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
</div>


{/* ================= NETWORK KULLANICILARI ================= */}
<div style={{ marginTop: 40 }}>
  <div style={styles.card}>
    <div
      onClick={() => setNetworkOpen(!networkOpen)}
      style={{
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer",
        fontWeight: 800,
        fontSize: 18
      }}
    >
      <span>🌐 Network / Bayi Ekipleri ({filteredNetworkRows.length})</span>
      <span>{networkOpen ? "−" : "+"}</span>
    </div>

    {networkOpen && (
      <div style={{ marginTop: 20 }}>
        <div style={{ marginBottom: 14, padding: 13, borderRadius: 14, background: "linear-gradient(135deg,#eff6ff,#f8fafc)", border: "1px solid #bfdbfe", color: "#1e3a5f", fontSize: 13, lineHeight: 1.6 }}>
          <b>Ağaç yönetimi:</b> Masaüstünde bir bayi kartını tutup yeni üst bayinin kartına bırakabilirsin. Telefon ve tablette kartı açıp “Yeni üst bayi” alanından seçim yapabilirsin. Taşınan bayinin bütün alt ekibi birlikte korunur.
        </div>
        <div
          className="bayi-admin-network-toolbar"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 10,
            marginBottom: 14,
          }}
        >
          <input
            style={styles.input}
            placeholder="Tayfun Unac, firma, e-posta, telefon veya kod ara..."
            value={networkSearch}
            onChange={e => setNetworkSearch(e.target.value)}
          />

          <select
            style={styles.input}
            value={networkOwnerFilter}
            onChange={e => setNetworkOwnerFilter(e.target.value)}
          >
            <option value="">Tüm ekipler</option>
            {networkOwners.map(owner => (
              <option key={owner} value={owner}>
                {owner}
              </option>
            ))}
          </select>

          <button
            type="button"
            style={styles.primaryBtn}
            onClick={() => {
              fetchNetworkUsers();
              fetchBayiBasvurulari();
            }}
          >
            Yenile
          </button>
        </div>

        <div className="bayi-admin-network-tree">
          {networkForest.map((node) => renderNetworkNode(node))}

          {!networkForest.length && (
            <div style={styles.emptyState}>
              <div style={styles.emptyIcon}>🌐</div>
              <b>Bu filtreye uygun ekip kaydı yok</b>
              <span>Arama veya ekip filtresini değiştirip yeniden deneyebilirsin.</span>
            </div>
          )}
        </div>
      </div>
    )}
  </div>
</div>

</div>



</div>
  );
}

/* ================= STYLES ================= */
const styles = {
  page: {
    minHeight: "100vh",
    padding: 24,
    background:
      "radial-gradient(circle at top left, rgba(37,99,235,.12), transparent 28%), linear-gradient(135deg, #f8fafc 0%, #eef2ff 45%, #fff7ed 100%)",
    color: "#0f172a",
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  },

  hero: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 18,
    marginBottom: 22,
    padding: "24px 26px",
    borderRadius: 24,
    background:
      "linear-gradient(135deg, rgba(15,23,42,.98), rgba(30,64,175,.96))",
    color: "#fff",
    boxShadow: "0 24px 60px rgba(15,23,42,.22)",
    position: "relative",
    overflow: "hidden"
  },

  kicker: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px",
    borderRadius: 999,
    background: "rgba(255,255,255,.12)",
    color: "#bfdbfe",
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: ".04em",
    textTransform: "uppercase",
    marginBottom: 10
  },

  heroTitle: {
    margin: 0,
    fontSize: 34,
    lineHeight: 1.1,
    fontWeight: 900,
    letterSpacing: "-.04em"
  },

  heroText: {
    margin: "10px 0 0",
    maxWidth: 680,
    color: "#dbeafe",
    fontSize: 15,
    lineHeight: 1.6,
    fontWeight: 500
  },

  heroActions: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    justifyContent: "flex-end"
  },

  heroBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 13px",
    borderRadius: 999,
    background: "rgba(255,255,255,.12)",
    border: "1px solid rgba(255,255,255,.18)",
    color: "#fff",
    fontSize: 13,
    fontWeight: 800,
    whiteSpace: "nowrap"
  },

  heroDot: {
    width: 9,
    height: 9,
    borderRadius: "50%",
    background: "#22c55e",
    boxShadow: "0 0 0 5px rgba(34,197,94,.18)"
  },

  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 14,
    marginBottom: 20
  },

subeTabs: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 8,
  marginBottom: 10,
},

subeTabBtn: {
  border: "none",
  padding: "11px 12px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
},

subeHelper: {
  padding: 12,
  borderRadius: 12,
  background: "#fff7ed",
  border: "1px solid #fed7aa",
  color: "#9a3412",
  fontSize: 13,
  fontWeight: 750,
  lineHeight: 1.45,
  marginBottom: 12,
},

linkedBadge: {
  padding: "3px 8px",
  borderRadius: 999,
  background: "#dbeafe",
  color: "#1d4ed8",
  fontSize: 11,
  fontWeight: 900,
},

subeLinkBtn: {
  gridColumn: "1 / -1",
  border: "none",
  background: "linear-gradient(135deg, #f97316, #ea580c)",
  color: "#fff",
  padding: 12,
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},

subeDangerLightBtn: {
  border: "none",
  background: "#fff7ed",
  color: "#c2410c",
  padding: "8px 10px",
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},

  statCard: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: 18,
    borderRadius: 20,
    background: "rgba(255,255,255,.86)",
    border: "1px solid rgba(226,232,240,.95)",
    boxShadow: "0 16px 38px rgba(15,23,42,.08)",
    backdropFilter: "blur(12px)"
  },

  statIcon: {
    width: 44,
    height: 44,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
    background: "linear-gradient(135deg, #eff6ff, #fff7ed)",
    fontSize: 22,
    boxShadow: "inset 0 0 0 1px rgba(37,99,235,.08)"
  },

  statLabel: {
    fontSize: 12,
    color: "#64748b",
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: ".04em"
  },

  statValue: {
    marginTop: 2,
    fontSize: 24,
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: "-.03em"
  },

  layout: {
    display: "grid",
    gridTemplateColumns: "minmax(320px, .85fr) minmax(420px, 1.15fr)",
    gap: 20,
    alignItems: "start"
  },

  card: {
    background: "rgba(255,255,255,.92)",
    borderRadius: 24,
    padding: 22,
    border: "1px solid rgba(226,232,240,.95)",
    boxShadow: "0 24px 60px rgba(15,23,42,.10)",
    backdropFilter: "blur(14px)"
  },

  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
    marginBottom: 18
  },

  cardEyebrow: {
    color: "#2563eb",
    fontSize: 12,
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: ".05em",
    marginBottom: 4
  },

  cardTitle: {
    margin: 0,
    fontSize: 21,
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: "-.03em"
  },

  cardIcon: {
    width: 42,
    height: 42,
    borderRadius: 16,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #2563eb, #f97316)",
    color: "#fff",
    fontSize: 20,
    fontWeight: 900,
    boxShadow: "0 12px 28px rgba(37,99,235,.25)"
  },

  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 10
  },

  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "13px 14px",
    borderRadius: 14,
    border: "1px solid #dbe3ef",
    marginBottom: 0,
    outline: "none",
    background: "#f8fafc",
    color: "#0f172a",
    fontSize: 14,
    fontWeight: 650,
    transition: "all .18s ease"
  },

  searchInput: {
    width: "100%",
    boxSizing: "border-box",
    padding: "14px 15px",
    borderRadius: 16,
    border: "1px solid #dbe3ef",
    marginBottom: 14,
    outline: "none",
    background: "#f8fafc",
    color: "#0f172a",
    fontSize: 14,
    fontWeight: 700
  },

  primaryBtn: {
    width: "100%",
    padding: 15,
    borderRadius: 16,
    marginTop: 14,
    background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
    color: "#fff",
    fontWeight: 900,
    border: "none",
    cursor: "pointer",
    boxShadow: "0 16px 32px rgba(37,99,235,.25)"
  },

  logoutBtn: {
    padding: "11px 16px",
    borderRadius: 14,
    background: "#fff",
    color: "#0f172a",
    border: "none",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 12px 28px rgba(15,23,42,.18)"
  },

  bayiList: {
    display: "grid",
    gap: 10
  },

  accordion: {
    border: "1px solid #e2e8f0",
    borderRadius: 18,
    padding: 0,
    marginBottom: 0,
    background: "#fff",
    overflow: "hidden",
    boxShadow: "0 10px 26px rgba(15,23,42,.05)"
  },

  summary: {
    cursor: "pointer",
    fontWeight: 700,
    listStyle: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: 14
  },

  bayiSummaryLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0
  },

  avatar: {
    width: 46,
    height: 46,
    minWidth: 46,
    borderRadius: 16,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #f97316, #2563eb)",
    color: "#fff",
    fontSize: 18,
    fontWeight: 900,
    boxShadow: "0 12px 28px rgba(249,115,22,.22)"
  },

  bayiName: {
    color: "#0f172a",
    fontSize: 15,
    fontWeight: 900,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 320
  },

  bayiMeta: {
    marginTop: 3,
    color: "#64748b",
    fontSize: 12,
    fontWeight: 700
  },

  statusBadge: {
    padding: "7px 10px",
    borderRadius: 999,
    background: "#dcfce7",
    color: "#166534",
    fontSize: 12,
    fontWeight: 900,
    whiteSpace: "nowrap"
  },

  detail: {
    marginTop: 0,
    padding: "0 14px 14px",
    borderTop: "1px solid #f1f5f9"
  },

  detailGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 10,
    marginTop: 12
  },

  infoBox: {
    padding: 12,
    borderRadius: 14,
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    color: "#0f172a"
  },

  infoLabel: {
    display: "block",
    color: "#64748b",
    fontSize: 11,
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: ".04em",
    marginBottom: 5
  },

  deleteBtn: {
    marginTop: 12,
    width: "100%",
    padding: 12,
    borderRadius: 14,
    background: "linear-gradient(135deg, #f97316, #dc2626)",
    color: "#fff",
    border: "none",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 12px 26px rgba(249,115,22,.22)"
  },

  emptyState: {
    padding: 28,
    borderRadius: 18,
    background: "#f8fafc",
    border: "1px dashed #cbd5e1",
    color: "#64748b",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
    textAlign: "center",
    fontSize: 14
  },

  emptyIcon: {
    fontSize: 28,
    marginBottom: 4
  },

  th: {
    padding: 12,
    fontWeight: 900,
    fontSize: 13,
    color: "#334155",
    borderBottom: "2px solid #e5e7eb",
    whiteSpace: "nowrap"
  },

  td: {
    padding: 12,
    fontSize: 14,
    color: "#0f172a",
    whiteSpace: "nowrap"
  },

  approveBtn: {
    padding: "9px 14px",
    borderRadius: 12,
    background: "linear-gradient(135deg, #16a34a, #15803d)",
    color: "#fff",
    border: "none",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 10px 22px rgba(22,163,74,.22)"
  },

  message: {
    padding: 14,
    borderRadius: 16,
    marginBottom: 16,
    fontWeight: 800,
    border: "1px solid rgba(226,232,240,.85)",
    boxShadow: "0 12px 28px rgba(15,23,42,.07)"
  },

  loginPage: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "radial-gradient(circle at top, rgba(37,99,235,.16), transparent 30%), linear-gradient(135deg, #f8fafc, #eef2ff)"
  },
subeBox: {
  marginTop: 16,
  padding: 16,
  borderRadius: 14,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
},

subeTop: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "flex-start",
  marginBottom: 12,
},

subeTitle: {
  fontSize: 16,
  fontWeight: 900,
  color: "#0f172a",
},

subeDesc: {
  fontSize: 13,
  color: "#64748b",
  marginTop: 4,
  lineHeight: 1.4,
},

subeToggleBtn: {
  border: "none",
  color: "#fff",
  padding: "9px 12px",
  borderRadius: 999,
  fontWeight: 800,
  cursor: "pointer",
  whiteSpace: "nowrap",
},

subeRefreshBtn: {
  width: "100%",
  padding: 11,
  borderRadius: 10,
  border: "1px solid #bfdbfe",
  background: "#eff6ff",
  color: "#1d4ed8",
  fontWeight: 800,
  cursor: "pointer",
  marginBottom: 12,
},

subeList: {
  display: "grid",
  gap: 10,
  marginBottom: 14,
},

subeItem: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "center",
  padding: 12,
  borderRadius: 12,
  background: "#fff",
  border: "1px solid #e5e7eb",
},

subeName: {
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontWeight: 900,
  color: "#0f172a",
},

subeMeta: {
  fontSize: 12,
  color: "#64748b",
  marginTop: 3,
},

defaultBadge: {
  padding: "3px 8px",
  borderRadius: 999,
  background: "#dcfce7",
  color: "#166534",
  fontSize: 11,
  fontWeight: 900,
},

passiveBadge: {
  padding: "3px 8px",
  borderRadius: 999,
  background: "#fee2e2",
  color: "#991b1b",
  fontSize: 11,
  fontWeight: 900,
},
subePassiveBtn: {
  border: "none",
  background: "#fee2e2",
  color: "#991b1b",
  padding: "8px 10px",
  borderRadius: 10,
  fontWeight: 800,
  cursor: "pointer",
},

subeEmpty: {
  padding: 12,
  borderRadius: 10,
  background: "#fff",
  color: "#64748b",
  fontSize: 13,
  border: "1px dashed #cbd5e1",
},

subeForm: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 10,
},

subeAddBtn: {
  gridColumn: "1 / -1",
  border: "none",
  background: "#2563eb",
  color: "#fff",
  padding: 12,
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},
referansBox: {
  marginTop: 16,
  padding: 16,
  borderRadius: 16,
  background: "linear-gradient(135deg, #ffffff, #f8fafc)",
  border: "1px solid #e2e8f0",
  boxShadow: "0 14px 34px rgba(15,23,42,.06)",
},

referansTop: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "flex-start",
  marginBottom: 14,
},

referansTitle: {
  fontSize: 16,
  fontWeight: 900,
  color: "#0f172a",
},

referansDesc: {
  fontSize: 13,
  color: "#64748b",
  marginTop: 4,
  lineHeight: 1.45,
},

referansInfoBadge: {
  padding: "7px 12px",
  borderRadius: 999,
  background: "#eff6ff",
  color: "#1d4ed8",
  border: "1px solid #bfdbfe",
  fontSize: 12,
  fontWeight: 900,
  whiteSpace: "nowrap",
},

referansForm: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 10,
  padding: 12,
  borderRadius: 14,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
},

referansTextArea: {
  gridColumn: "1 / -1",
  minHeight: 78,
  padding: 12,
  borderRadius: 12,
  border: "1px solid #d1d5db",
  outline: "none",
  resize: "vertical",
  fontFamily: "inherit",
  fontWeight: 700,
  color: "#0f172a",
  background: "#fff",
},

referansActions: {
  gridColumn: "1 / -1",
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
},

referansSaveBtn: {
  flex: 1,
  border: "none",
  background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
  color: "#fff",
  padding: 12,
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
  boxShadow: "0 12px 24px rgba(37,99,235,.22)",
},

referansCancelBtn: {
  border: "none",
  background: "#e2e8f0",
  color: "#0f172a",
  padding: "12px 16px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
},

referansList: {
  display: "grid",
  gap: 10,
  marginTop: 14,
},

referansItem: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "stretch",
  padding: 14,
  borderRadius: 14,
  background: "#fff",
  border: "1px solid #e5e7eb",
},

referansItemMain: {
  flex: 1,
  minWidth: 0,
},

referansItemHeader: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 10,
  flexWrap: "wrap",
  marginBottom: 6,
  color: "#0f172a",
},

referansSmallBadge: {
  padding: "5px 10px",
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 900,
  background: "#fff7ed",
  color: "#9a3412",
  border: "1px solid #fed7aa",
  whiteSpace: "nowrap",
},

referansMeta: {
  fontSize: 12,
  color: "#64748b",
  marginTop: 3,
},

referansNote: {
  marginTop: 10,
  padding: 10,
  borderRadius: 10,
  background: "#f8fafc",
  border: "1px dashed #cbd5e1",
  color: "#475569",
  fontSize: 12,
  lineHeight: 1.45,
},

referansItemActions: {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  minWidth: 100,
},

referansEditBtn: {
  border: "none",
  background: "#dbeafe",
  color: "#1e40af",
  padding: "9px 10px",
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},

referansDeleteBtn: {
  border: "none",
  background: "#fee2e2",
  color: "#991b1b",
  padding: "9px 10px",
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},

referansEmpty: {
  padding: 14,
  borderRadius: 12,
  background: "#fff",
  color: "#64748b",
  fontSize: 13,
  border: "1px dashed #cbd5e1",
},

kurumEditBox: {
  marginTop: 14,
  padding: 16,
  borderRadius: 16,
  background: "linear-gradient(135deg, #ffffff, #f8fafc)",
  border: "1px solid #e2e8f0",
  boxShadow: "0 12px 28px rgba(15,23,42,.05)",
},

kurumEditTop: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "flex-start",
},

kurumEditTitle: {
  fontSize: 16,
  fontWeight: 900,
  color: "#0f172a",
},

kurumEditDesc: {
  fontSize: 13,
  color: "#64748b",
  marginTop: 4,
  lineHeight: 1.45,
},

kurumEditToggleBtn: {
  border: "none",
  background: "linear-gradient(135deg, #f97316, #ea580c)",
  color: "#fff",
  padding: "10px 14px",
  borderRadius: 999,
  fontWeight: 900,
  cursor: "pointer",
  whiteSpace: "nowrap",
  boxShadow: "0 10px 20px rgba(249,115,22,.22)",
},

kurumEditForm: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 10,
  marginTop: 14,
  padding: 12,
  borderRadius: 14,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
},

kurumEditPasswordNote: {
  display: "flex",
  alignItems: "center",
  padding: "10px 12px",
  borderRadius: 12,
  background: "#eff6ff",
  border: "1px solid #bfdbfe",
  color: "#1d4ed8",
  fontSize: 12,
  fontWeight: 800,
},

kurumEditActions: {
  gridColumn: "1 / -1",
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
},

kurumEditSaveBtn: {
  flex: 1,
  border: "none",
  background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
  color: "#fff",
  padding: 12,
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
  boxShadow: "0 12px 24px rgba(37,99,235,.22)",
},

kurumEditCancelBtn: {
  border: "none",
  background: "#e2e8f0",
  color: "#0f172a",
  padding: "12px 16px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
},
kademeTabs: {
  gridColumn: "1 / -1",
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: 8,
},

kademeBtn: {
  border: "none",
  padding: "11px 12px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
},

kademeRate: {
  fontSize: 12,
  fontWeight: 900,
  opacity: 0.9,
},

hakedisPreviewMini: {
  gridColumn: "1 / -1",
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: 10,
  padding: 12,
  borderRadius: 14,
  background: "#fff7ed",
  border: "1px solid #fed7aa",
  color: "#9a3412",
},

dateFieldBox: {
  display: "grid",
  gap: 6,
},

dateLabel: {
  fontSize: 12,
  fontWeight: 900,
  color: "#475569",
},
kademeManualBox: {
  display: "grid",
  gridTemplateColumns: "1fr 110px",
  gap: 8,
  alignItems: "center",
  padding: 8,
  borderRadius: 14,
  border: "1px solid #e2e8f0",
},

kademeSelectBtn: {
  border: "none",
  padding: "11px 12px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
},

kademeInput: {
  width: "100%",
  border: "1px solid #cbd5e1",
  borderRadius: 10,
  padding: "10px 9px",
  fontWeight: 900,
  outline: "none",
},


  loginCard: {
    background: "rgba(255,255,255,.94)",
    padding: 32,
    borderRadius: 24,
    width: 380,
    border: "1px solid #e2e8f0",
    boxShadow: "0 24px 70px rgba(15,23,42,.16)"
  }
};

/* =====================================================
   MOBILE RESPONSIVE OVERRIDE
===================================================== */

if (typeof window !== "undefined") {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    styles.page.padding = 12;

    styles.hero.flexDirection = "column";
    styles.hero.alignItems = "flex-start";
    styles.hero.padding = 18;
    styles.heroTitle.fontSize = 28;

    styles.heroActions.width = "100%";
    styles.heroActions.justifyContent = "space-between";

    styles.statsGrid.gridTemplateColumns = "1fr 1fr";
    styles.statCard.padding = 14;

    styles.layout.gridTemplateColumns = "1fr";

    styles.card.padding = 16;

    styles.logoutBtn.width = "100%";

    styles.loginCard.width = "92%";

styles.subeForm.gridTemplateColumns = "1fr";
styles.subeTabs.gridTemplateColumns = "1fr";
    styles.bayiName.maxWidth = 180;

    styles.th.fontSize = 12;
    styles.td.fontSize = 13;

styles.referansTop.flexDirection = "column";
styles.referansInfoBadge.width = "100%";
styles.referansInfoBadge.textAlign = "center";
styles.referansForm.gridTemplateColumns = "1fr";
styles.referansItem.flexDirection = "column";
styles.referansItemActions.flexDirection = "row";
styles.referansItemActions.minWidth = "100%";
styles.referansEditBtn.flex = 1;
styles.referansDeleteBtn.flex = 1;
styles.kurumEditTop.flexDirection = "column";
styles.kurumEditToggleBtn.width = "100%";
styles.kurumEditForm.gridTemplateColumns = "1fr";
styles.kurumEditPasswordNote.gridColumn = "1 / -1";
styles.kurumEditActions.flexDirection = "column";
styles.kurumEditSaveBtn.width = "100%";
styles.kurumEditCancelBtn.width = "100%";
styles.kademeTabs.gridTemplateColumns = "1fr";
styles.hakedisPreviewMini.gridTemplateColumns = "1fr";


    // ✅ ŞUBE MOBİL DÜZENİ
    styles.subeTop.flexDirection = "column";
    styles.subeToggleBtn.width = "100%";
    styles.subeForm.gridTemplateColumns = "1fr";
    styles.subeItem.flexDirection = "column";
    styles.subeItem.alignItems = "stretch";
  }
}
